// Worthify i18n — PL locale. Keys must mirror locales/en.js;
// missing keys fall back to English in useTranslation.
export const pl = {
    // Header
    tagline: "Czy naprawdę warto?",
    
    // Main heading
    mainHeading: "Poznaj prawdziwą wartość!",
    heroSubtext: "Jedno szybkie sprawdzenie dziś może zaoszczędzić Ci tysiące później.",
    heroLine1: "Poznaj ryzyko zanim przekażesz pieniądze.",
    heroLine2: "Zamieniamy historię MOT w prostą, zrozumiałą poradę zakupową.",
    heroLine3: "Żebyś rozpoznał złą okazję, zanim stanie się Twoim problemem.",
    
    // Input placeholders
    registrationPlaceholder: "Wpisz numer rejestracyjny (UK)",
    pricePlaceholder: "Wprowadź cenę zakupu (£)",
    priceHelperText: "Wprowadź cenę zakupu (£)",
    listingUrlPlaceholder: "URL ogłoszenia (opcjonalne)",
    vinPlaceholder: "Wprowadź numer VIN",
    vinHelperText: "np. WAUZZZ4L1BD123456",
    vinInvalid: "Nieprawidłowy format VIN (musi mieć 17 znaków)",
    vinTooltip: "VIN pozwala dopasować dokładny silnik i specyfikację auta, dzięki czemu raport jest dokładniejszy",
    vinPreviewLoading: "Dekodujemy VIN…",
    vinPreviewDetected: "Wykryto",
    vinPreviewUnknown: "Nie udało się rozkodować VIN — analiza i tak zadziała",
    regHelperText: "Wpisz numer rejestracyjny (UK)",
    ctaHelperText: "Poznaj ukryte usterki, przewidywane koszty napraw i swoją pozycję negocjacyjną.",
    
    // Buttons
    analyzeButton: "SPRAWDŹ ZA DARMO",
    checkingVehicle: "Sprawdzanie pojazdu...",
    trustText: "Bez logowania • Prawdziwe dane DVSA + DVLA • 🛡 More Than HPI Check • Natychmiastowy werdykt",
    downloadButton: "Pobierz pełny raport (tylko £1)",
    generatingPdf: "Generowanie PDF...",
    newSearch: "← Nowe wyszukiwanie",
    
    // Error messages
    errorEmptyRegistration: "Proszę wprowadzić numer rejestracyjny pojazdu",
    errorVehicleNotFound: "Pojazd nie znaleziony. Sprawdź numer rejestracyjny.",
    errorServiceUnavailable: "Usługa niedostępna, spróbuj ponownie.",
    errorReportFailed: "Nie udało się wygenerować raportu. Spróbuj ponownie.",
    
    // Results - Risk level
    riskLevel: "Poziom ryzyka",
    tickerFailedMots: "NIEZDANE MOT",
    tickerMiles: "MIL",
    tickerDangerous: "NIEBEZPIECZNE",
    verdictWorthBuying: "DOBRA OFERTA",
    verdictBeCareful: "ZACHOWAJ OSTROŻNOŚĆ",
    verdictAvoid: "UNIKAJ",
    verdictExplanationLow: "Dostępne dane sugerują, że to jedna z bezpieczniejszych ofert. Historia wygląda czysto, ryzyko jest pod kontrolą i nic nie wskazuje na przykrą niespodziankę zaraz po zakupie.",
    verdictShortExplanationLow: "Historia wygląda czysto. Sprawdź auto zanim zapłacisz.",
    verdictShortExplanationMedium: "W historii są znane problemy. Tylko przy odpowiedniej cenie.",
    verdictShortExplanationHigh: "Poważne ryzyko. Przygotuj budżet na naprawy — albo odejdź.",
    verdictShortExplanationScam: "Cena podejrzanie niska. Traktuj jak zakup wysokiego ryzyka.",
    verdictExplanationMedium: "Widać tu kilka powodów do ostrożności, ale nie na tyle, by od razu rezygnować. Wejdź w tę ofertę świadomie, sprawdź auto dokładnie i wykorzystaj wykryte problemy w negocjacjach.",
    verdictExplanationHigh: "To nie są drobne sygnały ostrzegawcze, tylko realne ryzyko. Jeśli je zignorujesz, rachunki za naprawy mogą bardzo szybko zjeść całą pozorną okazję.",
    verdictExplanationScam: "Ta oferta jest dużo tańsza, niż powinna, a to często oznacza, że ryzyko zostało ukryte w cenie. Potraktuj to jako poważne ostrzeżenie, a nie szczęśliwy traf.",
    verdictSubtextLow: "Warto rozważyć zakup, jeśli stan auta na żywo potwierdzi dokumenty i historię.",
    verdictSubtextMedium: "Jest tu coś, co wymaga bliższego sprawdzenia zanim wydasz pieniądze.",
    verdictSubtextHigh: "Po zakupie zbyt wiele może pójść źle, żeby podejść do tej decyzji spokojnie.",
    verdictSubtextScam: "Niska cena może przyciągać, ale konsekwencje mogą być znacznie droższe.",
    unlockFullReport: "ODBLOKUJ PEŁNY RAPORT OCHRONY KUPUJĄCEGO — TYLKO £1",
    verdictIncludesLine1: "Jasne wyjaśnienie ryzyka, możliwe koszty, przewaga negocjacyjna i ukryte sygnały ostrzegawcze",
    verdictIncludesLine2: "Bez konta • Natychmiastowy dostęp • Stworzone dla prawdziwych kupujących",
    verdictClarityLine: "Dostęp dotyczy tylko tej sesji",
    verdictAvoidMistakes: "Dowiedz się, co może kosztować Cię pieniądze, zanim sprzedawca je dostanie",
    verdictTrustedBy: "Zaufany przez kupujących auta w UK",
    verdictSecureLine: "Bezpieczna płatność • Prawdziwa historia DVSA • Proste wyjaśnienia bez żargonu",
    whatYouUnlock: "Co odblokujesz",
    unlockItem1: "Problemy, które najpewniej będą kosztować Cię pieniądze po zakupie",
    unlockItem2: "Wzorce przebiegu mogące wskazywać na nadużycie lub manipulację",
    unlockItem3: "Ekspozycja na koszty napraw wyjaśniona prostym językiem",
    unlockItem4: "Ile realnie możesz urwać z ceny ofertowej",
    unlockItem5: "",
    expertiseUnlockCta: "Odblokuj premium",
    verdictScamTitle: "Wykryto cenę oszustwa",
    verdictOverpricedTitle: "Zawyżona cena vs rynek",
    verdictSuspiciousTitle: "Podejrzanie niska cena",
    verdictOverpricedSub: "Cena {subj} to {pct}% wartości rynkowej ({median}) — znacznie powyżej uczciwej ceny.",
    verdictScamSub: "Cena {subj} to tylko {pct}% wartości rynkowej ({median}) — typowy profil oszustwa.",
    verdictSuspiciousSub: "Cena {subj} to tylko {pct}% wartości rynkowej ({median}) — podejrzanie nisko.",
    unlockItemScore: "Worthify Score z pełną analizą",
    unlockItemTopRisk: "Podsumowanie kluczowego ryzyka",
    unlockItemPriceCheck: "Wykrywanie oszustw cenowych i zawyżeń",
    unlockItemNegotiation: "Argumenty negocjacyjne (z kwotami £)",
    unlockItemCrashTest: "Crash test i ocena bezpieczeństwa",
    unlockItemAccident: "Sprawdzenie historii wypadków",
    unlockItemWriteOff: "Sprawdzenie write-off / szkody całkowitej",
    unlockItemTheft: "Sprawdzenie kradzieży",
    unlockItemFinance: "Sprawdzenie zaległego finansowania",
    unlockItemImport: "Historia importu / eksportu",
    unlockItemInsurance: "Grupa ubezpieczeniowa",
    unlockItemUlez: "Werdykt ULEZ i CAZ — opłaty dzienne",
    unlockItemCo2: "Emisja CO₂ i ocena Eco",
    unlockItemRunningCosts: "Prognoza kosztów eksploatacji 5 lat",
    unlockItemDepreciation: "Prognoza utraty wartości",
    unlockItemTyresBrakes: "Analiza zużycia opon i hamulców",
    unlockItemEngineAnalysis: "Analiza silnika",
    unlockItemAnomalies: "Anomalie i flagi diagnostyczne",
    unlockItemMotHistory: "Szczegółowa historia MOT i usterek",
    unlockItemFailedMots: "Szczegóły niezdanych MOT",
    unlockItemRecurring: "Wykrywanie powtarzających się usterek",
    unlockItemOwners: "Historia właścicieli i V5C",
    unlockItemSimilarSold: "Podobne sprzedane pojazdy",
    unlockItemTaxMot: "Aktualny status podatku i MOT (DVLA)",
    unlockItemVin: "VIN ↔ DVLA — porównanie (wykrywanie klonów)",
    unlockItemEngineExpert: "Werdykt eksperta od silnika",
    unlockItemPlatformExpert: "Werdykt eksperta od platformy",
    unlockItemRiskExpert: "Werdykt eksperta ds. ryzyka",
    unlockItemPdf: "Pełen raport PDF do pobrania",
    limitedOffer: "Cena startowa: £1",
    unlockCtaNew: "Odblokuj pełny raport za £1 →",
    poweredByLine: "Jednorazowy dostęp • Prawdziwe dane • Analiza ekspercka",
    verdictHighCostWarning: "To może kosztować Cię więcej niż sam samochód.",
    verdictBackLink: "← Wstecz",
    paymentProcessing: "Przetwarzanie płatności...",
    checkingPayment: "Sprawdzanie statusu płatności...",
    paymentConfirmedTitle: "Płatność potwierdzona!",
    paymentConfirmedSub: "Przygotowujemy Twój raport…",
    paymentVerifyTitle: "Sprawdzamy status płatności…",
    paymentVerifySub: "Potwierdzamy Twoją płatność w Stripe — zwykle trwa to kilka sekund. Nie zamykaj tego okna.",
    paymentVerifySecure: "Bezpieczna płatność Stripe",
    pdfDownloadedToast: "✓ Raport pobrany",
    paymentVerifyingBanner: "Weryfikujemy płatność. PDF zacznie pobierać się automatycznie, gdy tylko płatność zostanie potwierdzona.",
    // ─── Launch-readiness (Feb 2026) — share, cancel, accessibility, 429 ───
    paymentCancelledTitle: "Płatność anulowana",
    paymentCancelledBody: "Nie pobrano żadnej opłaty. Możesz spróbować ponownie, kiedy będziesz gotowy.",
    errorRateLimit: "Zbyt wiele sprawdzeń w krótkim czasie. Poczekaj kilka minut i spróbuj ponownie.",
    errorRateLimitPayment: "Zbyt wiele prób płatności. Poczekaj kilka minut i spróbuj ponownie.",
    analyzingReassurance: "Analiza zajmuje zwykle 30–60 sekund",
    shareWithMechanicCta: "Wyślij mechanikowi",
    shareWithMechanicKicker: "Druga opinia? Wyślij raport zaufanemu mechanikowi.",
    shareReportMessage: "Sprawdź ten raport pojazdu z Worthify",
    shareReportCopied: "Link skopiowany",
    shareReportCopyManual: "Skopiuj ten link:",
    preCheckoutBenefitValuation: "Wycena rynkowa",
    preCheckoutBenefitRecall: "Recalle i historia szkód",
    preCheckoutBenefitMot: "Analiza ryzyka MOT",
    preCheckoutBenefitShare: "PDF + udostępnij mechanikowi",
    preCheckoutTickToContinue: "Zaznacz zgodę, aby kontynuować",
    // ─── Hero HPI badge + modal (Feb 2026 positioning) ───────────
    heroHpiBadgeText: "More Than HPI Check",
    heroHpiBadgeAria: "Dowiedz się więcej o More Than HPI Check",
    moreHpiModalTitle: "Dlaczego Worthify jest inny?",
    moreHpiModalSubtitle: "Najlepsza platforma do analizy pojazdów w UK pod względem ceny",
    moreHpiIntroLead: "Worthify nie tylko pokazuje dane pojazdu — wyjaśnia je.",
    moreHpiIntroBody: "More Than HPI Check — Worthify łączy zaufane brytyjskie dane pojazdu, wycenę rynkową i analizę AI w jednym, czytelnym raporcie.",
    moreHpiValueKicker: "Po co płacić £30+?",
    moreHpiValueBody: "Worthify dostarcza zaawansowane dane pojazdu, wycenę rynkową, analizę MOT i wnioski AI dla kupującego — wszystko za jedyne ",
    moreHpiValueBodyEnd: ".",
    moreHpiIncludedTitle: "Co dostajesz w raporcie Premium",
    hpiIncludedFinance: "Sprawdzenie kredytów / finansowania",
    hpiIncludedStolen: "Sprawdzenie kradzieży",
    hpiIncludedWriteOff: "Kategoria szkody (A, B, S, N)",
    hpiIncludedVin: "Weryfikacja VIN",
    hpiIncludedIdentity: "Weryfikacja tożsamości pojazdu",
    hpiIncludedMileage: "Wykrywanie anomalii przebiegu",
    hpiIncludedMot: "Analiza historii MOT",
    hpiIncludedRisk: "Ocena ryzyka pojazdu",
    hpiIncludedMarket: "Wycena rynkowa",
    hpiIncludedWorthifyValue: "Wycena Worthify Value",
    hpiIncludedPlate: "Historia zmian tablic",
    hpiIncludedImport: "Status importu / eksportu",
    hpiIncludedAi: "Wnioski AI dla kupującego",
    hpiIncludedPdf: "Eksport raportu PDF",
    hpiIncludedShare: "Wyślij mechanikowi",
    moreHpiNoKnowTitle: "Bez wiedzy mechanicznej",
    moreHpiNoKnowBody: "Worthify tłumaczy skomplikowane dane pojazdu na proste wyjaśnienia, które każdy zrozumie. Wiedz, co oznaczają dane, zanim wydasz pieniądze.",
    moreHpiEveryoneTitle: "Dla każdego",
    moreHpiEveryoneBody: "Stworzony dla codziennych kupujących auta, początkujących kierowców, rodzin, pasjonatów i doświadczonych kierowców. Niezależnie czy jesteś mechanikiem, czy kupujesz pierwsze auto — Worthify pomoże Ci zrozumieć co naprawdę oznaczają dane.",
    moreHpiMultilingualTitle: "Wsparcie wielojęzyczne",
    moreHpiMultilingualBody: "Raporty pojazdów i wyjaśnienia dostępne w wielu językach — sprawdzanie aut bardziej dostępne dla każdego w UK.",
    moreHpiFooterTrust: "Wykorzystujemy zaufane brytyjskie dane pojazdu i oficjalne źródła.",
    moreHpiFooterTagline: "Analiza pojazdu, nie tylko historia pojazdu.",
    moreHpiFooterChips: "🛡 More Than HPI Check · Analiza AI · Wycena rynkowa · Analizy premium",
    // ─── Global premium positioning (paywall + CTA areas) ────────
    premiumPositioningTagline: "More Than HPI Check",
    premiumPositioningSub: "Finanse · Kradzież · Szkody · VIN · AI · Wycena rynkowa",
    // ─── Pricing transparency (3 tiers inside More-Than-HPI modal) ──
    pricingTransparencyTitle: "Proste ceny. Pełna przejrzystość.",
    pricingTransparencySub: "Trzy poziomy. Płacisz tylko za głębię, której potrzebujesz.",
    tierFreeLabel: "POZIOM DARMOWY",
    tierFreeIntro: "Natychmiastowa rekomendacja, zanim wydasz choćby grosz.",
    tierFreeF1: "Rekomendacja Worthify (Unikaj · Uważaj · Dobra okazja)",
    tierFreeFooter: "Dowiedz się, czy auto warte jest dokładniejszego sprawdzenia.",
    tierStandardLabel: "POZIOM STANDARD",
    tierStandardIntro: "Odblokuj pełną analizę Worthify.",
    tierStdF1: "Pełny Worthify Buy Score (0–100)",
    tierStdF2: "Wnioski z konsensusu 3 AI",
    tierStdF3: "Szczegółowa analiza MOT i wzorców usterek",
    tierStdF4: "Mocne i słabe strony pojazdu",
    tierStdF5: "Analiza silnika i typowych usterek modelu",
    tierStdF6: "Opinie ekspertów (Mechanik · Dealer · Ekonomista)",
    tierStdF7: "Dźwignia negocjacyjna i kosztorys napraw",
    tierStdF8: "Analiza bezpieczeństwa / crash test",
    tierStdF9: "Wyślij mechanikowi",
    tierStdF10: "Wycena rynkowa Worthify",
    tierStandardFooter: "Zrozum, co naprawdę oznaczają dane pojazdu.",
    tierPremiumLabel: "POZIOM PREMIUM",
    tierPremiumBadge: "Najlepsza wartość",
    tierPremiumIntro: "More Than HPI Check.",
    tierPremiumIncludes: "Wszystko ze Standardu plus zaawansowane dane pojazdu:",
    tierPremF1: "Sprawdzenie kredytów / finansowania",
    tierPremF2: "Sprawdzenie kradzieży",
    tierPremF3: "Kategoria szkody ubezpieczeniowej (A, B, S, N)",
    tierPremF4: "Weryfikacja VIN (głęboka)",
    tierPremF5: "Weryfikacja tożsamości pojazdu",
    tierPremF6: "Wykrywanie anomalii przebiegu",
    tierPremF7: "Ocena ryzyka pojazdu",
    tierPremF8: "Historia zmian tablic",
    tierPremF9: "Status importu / eksportu",
    tierPremF10: "Wycena Worthify Value (dane premium)",
    tierPremF11: "Wnioski AI dla kupującego (model premium)",
    tierPremF12: "Raport PDF Premium (do pobrania)",
    tierPremiumFooter: "Wszystko, czego potrzebujesz, zanim wydasz tysiące na auto.",
    pricingFooterLine1: "Zacznij od darmowej rekomendacji.",
    pricingFooterLine2: "Płać tylko jeśli chcesz głębszych wniosków i premium analizy pojazdu.",
    // ─── More-Than-HPI modal v2 (3-col redesign) ────────────────────
    moreHpiHeaderTitle: "Dlaczego Worthify jest inny",
    moreHpiHeaderSub: "Najnowocześniejsza platforma do analizy pojazdów w UK — pomaga podjąć właściwą decyzję przed zakupem.",
    moreHpiHeroPre: "Worthify to ",
    moreHpiHeroHighlight: "More Than HPI Check",
    moreHpiHeroPost: ".",
    moreHpiHeroBody: "Łączymy zaufane dane UK, wycenę rynkową i analizę AI — by dać Ci jasne odpowiedzi, proste wyjaśnienia i realną pewność.",
    tierBestValue: "NAJLEPSZA WARTOŚĆ",
    tierNewPill: "NOWE",
    tierFreeName: "Natychmiastowa pomoc w decyzji",
    tierFreeIntro2: "Szybka rekomendacja, zanim wydasz choćby grosz.",
    tierFreeBuyRec: "Rekomendacja kupna",
    tierFreeBasicInfo: "Podstawowe informacje (Marka · Model · Rok)",
    tierFreeMot: "Status MOT (Zaliczony / Niezaliczony / Aktywny)",
    tierFreeTax: "Status podatku",
    tierFreeCallout: "Idealne, by wiedzieć, czy auto warto sprawdzać dalej.",
    tierFreeFooterQ: "Czy w ogóle warto rozważyć to auto?",
    tierStandardName: "Zrozum decyzję",
    tierStandardIntro2: "Odblokuj pełną analizę Worthify i zrozum ryzyka.",
    tierStdEverythingFree: "Wszystko z poziomu Darmowego",
    tierStdScore: "Pełny Worthify Buy Score (0–100)",
    tierStdAiExpl: "Analiza AI i wyjaśnienia",
    tierStdMot: "Szczegółowa analiza MOT",
    tierStdStrengths: "Mocne i słabe strony pojazdu",
    tierStdInitialRisk: "Wstępna ocena ryzyka",
    tierStandardCallout: "Zrozum, czy to dobra okazja, czy ryzykowny zakup.",
    tierStandardFooterQ: "Dlaczego to dobry lub zły zakup?",
    tierPremiumName: "More Than HPI Check",
    tierPremiumIntro2: "Pełne dane o pojeździe, wartość rynkowa i analiza ryzyka.",
    tierPremEverythingStd: "Wszystko z poziomu Standard",
    tierPremFinance: "Sprawdzenie kredytów / finansowania",
    tierPremStolen: "Sprawdzenie kradzieży",
    tierPremWriteOff: "Kategoria szkody (write-off)",
    tierPremVin: "Weryfikacja VIN",
    tierPremIdentity: "Weryfikacja tożsamości pojazdu",
    tierPremMileage: "Wykrywanie anomalii przebiegu",
    tierPremMotHistory: "Pełna historia MOT",
    tierPremRiskAdv: "Ocena ryzyka (zaawansowana)",
    tierPremMarket: "Wycena rynkowa",
    tierPremWorthifyValue: "Worthify Value (dane premium)",
    tierPremAiAdv: "Wnioski AI dla kupującego (zaawansowane)",
    tierPremNego: "Dźwignia negocjacyjna",
    tierPremPlate: "Historia zmian tablic",
    tierPremImport: "Status importu / eksportu",
    tierPremPdf: "Pobieranie raportu PDF",
    tierPremShare: "Wyślij mechanikowi",
    tierPremMulti: "Wsparcie wielojęzyczne",
    tierPremiumCallout: "Wszystko, czego potrzebujesz, zanim wydasz tysiące na auto.",
    tierPremiumFooterQ: "O jakich ryzykach powinienem wiedzieć przed zakupem?",
    moreHpiWhy30Title: "Po co płacić £30+ za tradycyjny raport pojazdu?",
    moreHpiWhy30Body: "Worthify łączy zaawansowaną analizę pojazdu, wycenę rynkową i analizę AI w jeden niedrogi raport. Bez żargonu. Tylko jasne odpowiedzi, którym możesz zaufać.",
    trustIconExplain: "Proste wyjaśnienia dla każdego",
    trustIconAi: "Analiza ryzyka AI, której możesz zaufać",
    trustIconUk: "Stworzone dla kupujących w UK i aut z UK",
    trustIconData: "Zaufane dane z oficjalnych źródeł UK",
    trustIconOne: "Jeden raport. Wszystko, czego potrzebujesz.",
    moreHpiSourcesLine: "Korzystamy ze sprawdzonych źródeł danych UK: DVLA, DVSA i wiodących dostawców vehicle data.",
    // ─── Suspicious-low asking-price (Feb 2026 launch fix) ──────────
    suspiciousPriceKicker: "Cena wygląda bardzo podejrzanie nisko",
    suspiciousPriceShort: "Cena £{asking} to tylko {pct}% rzeczywistej wartości £{market} — to albo oszustwo, albo ukryte usterki. Odpuść, albo przygotuj się na naprawy.",
    suspiciousPriceCtaHint: "Dotknij, aby zobaczyć Price Check →",
    overpricedKicker: "Cena zawyżona vs wartość",
    overpricedShort: "Cena £{asking} to {pct}% rzeczywistej wartości £{market} — znacznie powyżej uczciwej ceny.",
    overpricedCtaHint: "Dotknij, aby zobaczyć Price Check →",
    priceTileAddAsking: "Dodaj cenę sprzedającego",
    priceTileAddAskingSub: "Dotknij, aby wpisać cenę i otrzymać natychmiastowy werdykt.",
    negoSuspiciousKicker: "Cena już poniżej rynkowej",
    negoSuspiciousTitle: "Nie negocjuj w dół — najpierw zweryfikuj",
    negoSuspiciousCopy: "Cena £{asking} jest już o £{gap} niższa niż wartość rynkowa tego auta (£{market}). Nawet po uwzględnieniu napraw za £{rLo}–£{rHi}, uczciwa cena to około £{fair}. Sprzedawca oferuje taniej. Zanim cokolwiek zapłacisz — dowiedz się, dlaczego.",
    negoMarketValueLabel: "Wartość rynkowa",
    negoFairWithRepairsLabel: "Uczciwa cena (z naprawami)",
    negoAskingLabel: "Cena ofertowa",
    negoSuspiciousAsk1: "Dlaczego cena jest poniżej rynkowej? (utrata pracy / pilna sprzedaż / ukryta wada?)",
    negoSuspiciousAsk2: "Poproś o pełne sprawdzenie historii + V5C + pełną historię serwisową przed wpłatą zaliczki",
    negoSuspiciousAsk3: "Obejrzyj osobiście — nigdy nie płać krypto / przelewem zagranicznym / kartami podarunkowymi",
    close: "Zamknij",
    trustText: "Bez logowania • Prawdziwe dane DVSA + DVLA • 🛡 More Than HPI Check • Natychmiastowy werdykt",
    redFlagsTitle: "Czerwone flagi",
    noRedFlags: "Brak czerwonych flag — czysta historia",
    yourAskingPrice: "Twoja cena ofertowa",
    marketMedianShort: "Realna wartość",
    suspiciousPrice: "Podejrzana — poniżej rynku",
    unlockReportCta: "ODBLOKUJ PEŁNY RAPORT OCHRONY KUPUJĄCEGO — TYLKO £1",
    pdfButtonSubtext: "Ryzyko, koszty i przewaga negocjacyjna w jednym raporcie",
    pdfButtonSubtext2: "Zapisz, wyślij dalej albo użyj w rozmowie ze sprzedawcą",
    lossWarning: "Możesz stracić {amount}",
    negotiationPowerTitle: "Siła Negocjacyjna",
    youCanNegotiate: "Zakres obniżki oparty na dowodach",
    expertScriptLabel: "Ekspercki skrypt negocjacyjny",
    copyMessage: "Skopiuj wiadomość",
    confirmedMotIssues: "potwierdzone usterki z MOT",
    expertSellerScript: "Dzień dobry — jestem naprawdę zainteresowany tym autem i gotowy do szybkiej decyzji. Zleciłem niezależną analizę historii MOT w Worthify i raport wskazuje {target} realnych, pilnych kosztów naprawy: {issues}. To nie są najgorsze scenariusze — to realny koszt doprowadzenia do porządku tego, co MOT już pokazuje. Żeby to uwzględnić, potrzebowałbym obniżki ceny o {target}.",
    expertSellerScriptClose: "Jeśli możemy dojść do {finalPrice}, jestem w stanie wszystko sfinalizować dzisiaj.",
    worthifyExpertsSuggest: "Eksperci Worthify sugerują negocjować",
    askingPriceLabel: "Cena wywoławcza",
    realValueWorthifyLabel: "Rzeczywista wartość (Worthify)",
    realValueGvdLabel: "Wartość rynkowa (rejestr DVLA)",
    navHome: "Start",
    navAbout: "O nas",
    navPricing: "Cennik",
    navFaq: "FAQ",
    navContact: "Kontakt",
    navDownloadApp: "Pobierz aplikację",
    downloadPageTitle: "Pobierz aplikację Worthify na telefon",
    downloadPageSubtitle: "Te same sprawdzenia auta w prostym języku, werdykt AI i narzędzia negocjacyjne — teraz jako aplikacja instalowana bezpośrednio ze strony worthify.co.uk.",
    downloadTagline: "Czy naprawdę warto? — błyskawiczne sprawdzenie ryzyka używanego auta.",
    downloadAndroidNote: "Zainstaluj plik .apk bezpośrednio — bez konta w Sklepie Play.",
    downloadAndroidCta: "Pobierz na Androida",
    downloadIosNote: "Apple nie pozwala instalować aplikacji bezpośrednio ze strony. Aplikacja na iOS pojawi się w App Store — na razie korzystaj z worthify.co.uk w przeglądarce Safari.",
    downloadComingSoon: "App Store — wkrótce",
    downloadInstallTitle: "Jak zainstalować na Androidzie",
    downloadStep1: "Kliknij „Pobierz na Androida” poniżej, aby zapisać plik .apk.",
    downloadStep2: "Otwórz plik — Android może poprosić o zgodę na instalację z tego źródła.",
    downloadStep3: "Potwierdź instalację i otwórz Worthify z ekranu głównego.",
    downloadTrustLine: "Oficjalna wersja Worthify · podpisana i bezpieczna · brak śledzenia bez zgody",
    downloadBannerTitle: "Pobierz aplikację",
    downloadBannerScan: "Zeskanuj, aby zainstalować na telefonie",
    downloadBannerCta: "Lub otwórz stronę pobierania →",
    scoreAdjustedBadge: "Zaktualizowano danymi premium",
    penaltyLabel_theft: "Zgłoszony jako skradziony",
    penaltyLabel_finance: "Niespłacone finansowanie",
    penaltyLabel_mileage_anomaly: "Anomalia przebiegu",
    penaltyLabelWriteOff: "Wpisany w szkodę całkowitą",
    penaltyLabelWriteOff_A: "Szkoda Cat A",
    penaltyLabelWriteOff_B: "Szkoda Cat B",
    penaltyLabelWriteOff_S: "Szkoda Cat S",
    penaltyLabelWriteOff_N: "Szkoda Cat N",
    penaltyLabelWriteOff_D: "Szkoda Cat D",
    penaltyLabelWriteOff_X: "Szkoda Cat X",
    penaltyPillAvoid: "Odradzamy",
    penaltyPillCaution: "Uwaga",
    plainEnglishKickerAvoid: "WERDYKT Z REJESTRU",
    plainEnglishKickerCaution: "WERDYKT Z REJESTRU",
    simpleExplanationCardSubAvoid: "Kliknij, aby zobaczyć dlaczego wynik spadł",
    simpleExplanationCardSubCaution: "Kliknij, aby zobaczyć ustalenia z rejestru",
    realValueWorthifySub: "z uwzględnieniem stanu i wad",
    anchorFreeBadge: "Niezależna · bez anchoringu",
    marketValueLabel: "Wartość rynkowa",
    worthifyValuationTitle: "Wycena Worthify",
    worthifyExpertValuesThisCarAt: "Eksperci Worthify wyceniają to auto na",
    withCurrentStateAndDefects: "z uwzględnieniem aktualnego stanu i wad",
    valuationGuidanceExplainer: "Idealnie cena wywoławcza powinna być blisko tej kwoty. Znacznie wyższa oznacza przepłacanie. Znacznie niższa to sygnał ostrzegawczy — ukryte uszkodzenia, kategoryzacja po szkodzie całkowitej lub oszustwo. Zapytaj zanim zapłacisz.",
    negotiationGapExplainer: "Cena wywoławcza {asking}, rzeczywista wartość Worthify {realValue}. Różnica {gap} odzwierciedla aktualny stan auta i powinna być elementem twoich negocjacji.",
    suspiciouslyCheapWarning: "Cena {asking} przy rzeczywistej wartości {realValue} jest nietypowo niska. Auta nie sprzedają się tak tanio bez powodu — sprawdź ukryte uszkodzenia, brakujące dokumenty, niespłacone finansowanie lub kategoryzację przed zapłatą.",
    fairOrBelowExplainer: "Cena {asking} przy rzeczywistej wartości {realValue} — to uczciwa lub nawet niższa od wyceny Worthify oferta. Nie ma znaczącej różnicy z samej wyceny, ale nadal możesz użyć listy kosztów napraw jako argumentu.",
    offTheAskingPrice: "mniej od ceny wywoławczej",
    basedOnTheseIssues: "Na podstawie tych potwierdzonych usterek",
    realisticRepairCost: "Realny koszt naprawy",
    priceAboveMarket: "Cena wywoławcza powyżej wartości rynkowej",
    overMarketValue: "powyżej typowej wartości rynkowej",
    negotiationExplainer: "Ta kwota odzwierciedla realny koszt naprawy tego, co faktycznie pokazuje MOT — nie najgorszych scenariuszy. Użyj jej jako punktu wyjścia w rozmowie ze sprzedającym.",
    useThisToLowerPrice: "Użyj tego zakresu, aby mocniej zbić cenę ofertową",
    totalRepairCostRange: "Zakres kosztów napraw",
    whatToSayToSeller: "Co powiedzieć sprzedawcy",
    verdictAvoidCar: "UNIKAJ TEGO AUTA",
    verdictShortBad: "Bardzo zła wartość.",
    verdictShortMedium: "Zachowaj ostrożność.",
    verdictShortGood: "Solidny zakup.",
    verdictSubShortBad: "Pojazd wysokiego ryzyka.",
    verdictSubShortMedium: "Wykryto pewne problemy.",
    verdictSubShortGood: "Pojazd z czystą historią.",
    scoreCardSubtext: "Koszty napraw \u00B7 Ukryte problemy \u00B7 Przewaga negocjacyjna",
    potentialLossTitle: "Potencjalna strata przy zakupie tego auta",
    overpricedByLabel: "Przepłacone o",
    totalPotentialLoss: "Całkowita potencjalna strata",
    totalEstimatedCost: "Całkowity szacunkowy koszt",
    detailedPotentialCosts: "Szczegółowe potencjalne ryzyka i koszty",
    bigCostHeadline: "Spodziewane przyszłe wydatki: {amount}",
    costSubtitleExplanation: "Realne koszty, na które warto się przygotować w ciągu najbliższych 12-24 miesięcy — wynikają z potwierdzonych usterek, charakterystyki silnika oraz typowych słabych punktów tej platformy.",
    expectedCostTitle: "Przewidywany koszt utrzymania (12–24 miesiące)",
    expectedCostTypicalSuffix: "typowo",
    expectedCostRangeSuffix: "realny zakres",
    expectedCostRelativePrefix: "≈",
    expectedCostRelativeSuffix: "wartości auta",
    expectedCostDriversTitle: "Powody:",
    expectedCostWorstTitle: "Czarny scenariusz",
    expectedCostWorstBody: "Nawet {amount}+ jeśli wystąpi poważna awaria ({worst_drivers}).",
    expectedCostFootnote: "Na podstawie historii MOT, znanych wzorców silnika i danych statystycznych o naprawach.",
    expectedCostNoData: "Na razie brak twardych kosztów do uwzględnienia — obserwuj kolejny serwis.",
    paywallTeaserLow: "Na papierze wygląda to rozsądnie. Pełna analiza pokaże ci, co warto sprawdzić zanim podpiszesz umowę.",
    paywallTeaserMedium: "Znaleźliśmy rzeczy, o których warto wiedzieć przed zapłatą. Otwórz pełny raport za £1.",
    paywallTeaserHigh: "Wiele sygnałów ostrzegawczych. Zobacz, ile to realnie kosztuje, zanim sprzedawca zobaczy twoje pieniądze.",
    paywallTeaserScam: "Cena wygląda zbyt dobrze, żeby była prawdziwa. Zobacz pełną analizę zanim wykonasz przelew.",
    paywallTeaserCTA: "Odblokuj pełny raport — £1",
    expertSellerScriptNoHistory: "Dzień dobry — jestem poważnie zainteresowany tym autem. Zleciłem niezależną wycenę w Worthify w oparciu o rodzinę silnika, dane o niezawodności platformy i aktualny stan — realna wartość wynosi {realValue}. Żeby transakcja była uczciwa dla obu stron, potrzebowałbym obniżki ceny o {target}.",
    expertSellerScriptValuationOnly: "Dzień dobry — chciałbym sfinalizować zakup w tym tygodniu. Niezależna wycena Worthify, oparta na silniku, platformie i stanie technicznym, daje realną wartość {realValue}. Jestem gotów zapłacić tę kwotę dzisiaj.",
    whyScoreTitle: "Dlaczego taka punktacja",
    whyScoreNoHistorySub: "Brak historii MOT, więc punktacja opiera się głównie na danych o silniku i platformie:",
    whyScoreWithHistorySub: "Wpływ tych czynników:",
    whyScoreFactorEngine: "Ryzyko rodziny silnika",
    whyScoreFactorPlatform: "Ryzyko platformy modelu",
    whyScoreFactorHistory: "Wzorzec historii MOT",
    whyScoreFactorUsage: "Profil użytkowania / przebiegu",
    whyScoreFactorSafety: "Wynik testów zderzeniowych",
    whyScoreNoHistoryHint: "Nowe auta bez historii badań startują z niższego poziomu, bo nie widzimy jeszcze, jak to konkretne auto było faktycznie używane i serwisowane — tylko to, jak ten silnik i platforma zachowują się średnio.",
    familyDeltaBetter: "Twój konkretny {make_model} wypada o {pts} pkt lepiej niż średnia {family}, którą sprawdziliśmy ({n} aut).",
    familyDeltaWorse: "Twój konkretny {make_model} wypada o {pts} pkt gorzej niż średnia {family}, którą sprawdziliśmy ({n} aut).",
    familyDeltaSame: "Twój konkretny {make_model} plasuje się dokładnie w średniej dla rodziny {family} ({n} aut sprawdzonych).",
    socialProofTitle: "Wzorzec w rodzinie tego silnika",
    socialProofSubtitle: "W {n} autach {family}, które przeanalizowaliśmy:",
    socialProofIssueRow: "{pct}% miało {issue}",
    confidenceBadgeLabel: "Pewność",
    confidenceHigh: "WYSOKA",
    confidenceMedium: "ŚREDNIA",
    confidenceLow: "NISKA",
    confidenceConsensus: "konsensus {n} AI",
    vinVerifiedLabel: "VIN zweryfikowany",
    vinVerifiedSource: "dekoder NHTSA",
    vinVerifiedTooltip: "Wariant silnika, wersja i fabryka rozpoznane z Twojego VIN — analiza dokładniejsza niż bez VIN.",
    loadingFactPeers: "Porównujemy z {n} autami {family}, które już sprawdziliśmy",
    loadingFactPeersFew: "Budujemy obraz dla tej rodziny silnika — mniej niż 5 podobnych aut",
    loadingFactMOT: "Czytamy {n} badań MOT z historii tego auta",
    loadingFactMOTNew: "Auto fabrycznie nowe — brak badań MOT w rejestrze",
    loadingFactAge: "{make} {model} ({year}) — pobieramy typowe słabe punkty",
    loadingFactScoring: "Uruchamiamy deterministyczny scoring Worthify — żadna AI nie decyduje sama",
    loadingFactSafety: "Sprawdzamy wyniki testów zderzeniowych Euro NCAP",
    minimalRisk: "Minimalne ryzyko",
    scoreLabel: "Worthify Score",
    riskFactors: "Czynniki ryzyka",
    fullAnalysisInPdf: "Pełne wyjaśnienie ryzyka, porady negocjacyjne i historia MOT w raporcie PDF",
    pdfUpsellTitle: "Pobierz pełny raport ochrony kupującego",
    pdfIncludes1: "Możliwe koszty napraw i dlaczego mają znaczenie",
    pdfIncludes2: "Przewaga negocjacyjna z realnymi widełkami w £",
    pdfIncludes3: "Jasna rada zakupowa oparta na faktach",
    pdfIncludes4: "Pełne rozbicie ryzyka prostym językiem",
    pdfIncludes5: "Wnioski o silniku, przebiegu i przyszłym użytkowaniu",
    topResultCta: "Chroń się",
    topResultSupportCopy: "Niezależnie od wyniku — jesteśmy po Twojej stronie. Realne koszty, realne argumenty, realna ochrona.",
    unlockSectionHeadline: "Nie powinieneś zgadywać, gdy w grę wchodzą prawdziwe pieniądze. Pobierz PDF z prostym wyjaśnieniem ryzyka, możliwymi kosztami, przewagą negocjacyjną i pełnym uzasadnieniem tego werdyktu.",
    unlockSectionCta: "Odblokuj PDF i pełne wskazówki kupującego za £1",
    resultVerdictLabel: "Werdykt",
    riskOutlookLabel: "Ocena ryzyka",
    potentialLossLabel: "Potencjalna strata",
    decisionMoodLabel: "Sygnał decyzji",
    heroCaptionHigh: "To auto może być bardzo drogie w utrzymaniu.",
    heroCaptionMedium: "Zastanów się dwa razy, zanim powiesz tak.",
    heroCaptionLow: "To wygląda bezpieczniej niż większość ofert.",
    costAlertLabel: "Alert kosztów",
    vehicleSnapshotLabel: "Szybki obraz auta",
    priorityReviewLabel: "Najważniejsze ryzyka",
    unlockPremiumSection: "Odblokuj sekcję premium",
    fullIssuesEyebrow: "Pełna lista problemów",
    advancedDataLabel: "Zaawansowane dane",
    pdfUnlockLabel: "Odblokowanie PDF",
    aiSummaryTitle: "Podsumowanie eksperckie",
    aiAnalysisTitle: "Ocena eksperta",
    riskExplanation: "Wyjaśnienie ryzyka",
    positivesTitle: "Co wygląda uspokajająco",
    negotiationInsight: "Wskazówki negocjacyjne",
    finalAdvice: "Ostateczna rada",
    topRiskTitle: "Najwazniejsze ryzyko",
    otherRisksTitle: "Inne potencjalne ryzyka",
    otherRisksSubtitle: "Typowe słabości tego silnika / platformy — nie potwierdzone w tym aucie.",
    repairCost: "Koszt naprawy",
    knownModelIssuesTitle: "Znane słabe punkty tego modelu",
    aiEstimatedValue: "Szacowana wartosc",
    priceEvalTitle: "Ocena ceny",
    evidenceTitle: "Dowody z MOT",
    expertNoteLabel: "Notatka eksperta",
    topIssueLabel: "Główny problem w tym aucie",
    topIssueLead: "Ta usterka została zapisana w historii MOT tego pojazdu.",
    topIssueLeadRecurring: "Ta usterka pojawiła się w {count} testach MOT i nadal jest w rejestrze — nie została naprawiona i z dużym prawdopodobieństwem będzie się pogarszać.",
    notConfirmedBadge: "Nie potwierdzone w tym aucie",
    engineFamilyContext: "Kontekst silnika / platformy",
    consequencesTitle: "Jesli zignorujesz",
    severityHigh: "WYSOKIE RYZYKO",
    severityMedium: "SREDNIE RYZYKO",
    severityLow: "NISKIE RYZYKO",
    engineAnalysisTitle: "Analiza silnika",
    engineIdentified: "Zidentyfikowany silnik",
    engineCode: "Kod silnika",
    engineKnownIssues: "Znane wady silnika",
    typicalWeaknessesTitle: "Typowe słabości tego silnika",
    typicalWeaknessesDisclaimer: "To są znane, potencjalne problemy dla TEJ RODZINY silnika — mogą się pojawić, ale nie muszą. Realne wady Twojego auta widać w historii MOT poniżej.",
    safetyRatingLabel: "Bezpieczeństwo (crash test)",
    safetyVerdictSafe: "Wysokie bezpieczeństwo — udowodnione w testach zderzeniowych",
    safetyVerdictAverage: "Średnie bezpieczeństwo — wystarczające, ale nie wybitne",
    safetyVerdictPoor: "Poniżej średniej — rozważ alternatywy",
    safetyRatingSource: "Niezależny test Euro NCAP",
    engineConfidence: "Pewnosc",
    mileageAnalysisTitle: "Analiza przebiegu",
    mileageHeroTitle: "Analiza\nprzebiegu",
    averageYearly: "Sredni roczny",
    milesPerYear: "mil/rok",
    mileageTrend: "Trend",
    trendStable: "Stabilny",
    trendHigh: "Wysoki przebieg",
    trendLow: "Niski przebieg",
    trendInconsistent: "Niestabilny",
    trendRollback: "Cofniecie licznika",
    trendUnknown: "Nieznany",
    mileageFlags: "Flagi",
    flagRollback: "Podejrzenie cofniecia licznika",
    flagLowUsage: "Bardzo niski przebieg",
    flagHighUsage: "Wysoki roczny przebieg",
    flagInconsistent: "Niestabilnosc przebiegu",
    aiMileageInsight: "Ekspercka analiza przebiegu",
    
    // Scam Detection
    scamWarning: "OSTRZEŻENIE CENOWE",
    scamAlertTitle: "Możliwe oszustwo wykryte",
    scamAlertDesc: "Ta cena jest podejrzanie niska. Może wskazywać na oszustwo, kradziony pojazd lub ukryte uszkodzenia.",
    scamRiskBadge: "WYSOKIE RYZYKO OSZUSTWA",
    suspiciousBadge: "PODEJRZANA CENA",
    overpricedBadge: "ZAWYŻONA CENA",
    fairPriceBadge: "UCZCIWA CENA",
    priceRange: "Zakres rynkowy",
    priceComparison: "Cena vs realna wartość",
    ofMarketValue: "realnej wartości",
    
    // Vehicle Information
    vehicleInfo: "Informacje o pojeździe",
    mileageLabel: "Przebieg",
    mileageVsAge: "mil/rok srednia wzgledem wieku",
    registration: "Rejestracja",
    makeModel: "Marka i model",
    year: "Rok",
    engine: "Silnik",
    engineCode: "Kod silnika",
    
    // Statistics
    totalTests: "Wszystkie testy",
    failedTests: "Niezdane testy",
    failsInLast3: "Niezdane w ostatnich 3",
    dangerousDefects: "Niebezpieczne usterki",
    recurringIssues: "Powtarzające się problemy",
    
    // Analysis sections
    aiExpertAnalysis: "Analiza ekspercka",
    priceAnalysis: "Analiza ceny",
    marketMedian: "Mediana rynkowa",
    typicalRange: "Typowy zakres",
    priceFlag: "Flaga cenowa",
    knownIssues: "Znane problemy tego modelu",
    anomaliesDetected: "Wykryte anomalie",
    recurringIssuesTitle: "Powtarzające się problemy",
    motTestHistory: "Historia badań MOT",
    detectedIssuesTitle: "Wykryte problemy",
    fullIssuesTitle: "Problemy",
    
    // Defect types
    advisory: "Zalecenie",
    major: "Poważna",
    dangerous: "Niebezpieczna",
    recurring: "Powtarzająca się",
    
    // MOT Timeline
    noDefectsFound: "✓ Brak usterek - czysty test",
    miles: "mil",
    expires: "Wygasa",
    appears: "Występuje",
    times: "razy",
    
    // Anomaly descriptions
    mileageDrop: "Odczyt licznika zmniejszył się między testami - możliwa manipulacja",
    coolingSystemFlags: "Wykryto problemy z układem chłodzenia w historii MOT",
    chainIssueSuspected: "Potencjalne problemy z łańcuchem rozrządu (częste w tym silniku)",
    
    // Sources
    sources: "Źródła",
    link: "Link",

    // Loading overlay
    analyzingTitle: "Analizowanie historii pojazdu...",
    loadingStep1: "Sprawdzanie historii MOT...",
    loadingStep2: "Wykrywanie ukrytych problemów...",
    loadingStep3: "Analiza wzorców przebiegu...",
    loadingStep4: "Identyfikacja ryzyk silnika...",
    loadingStep5: "Szacowanie kosztów napraw...",
    loadingStep6: "Weryfikacja anomalii...",
    loadingIssuesDetected: "Wykryto potencjalne problemy...",
    loadingFinalizing: "Finalizacja oceny ryzyka...",
    aiWorking: "Eksperci analizują...",
    aiDispatch: "Zwołujemy ekspertów...",
    aiRoleEngine: "Ekspert silnika",
    aiRolePlatform: "Ekspert platformy",
    aiRoleRisk: "Ekspert ryzyka",
    expertConfirmBadge: "Potwierdzone przez 3 ekspertów",
    expertConfirmTitle: "Zespół ekspertów potwierdził",
    expertConfirmSubtitle: "3 niezależnych ekspertów przeanalizowało pełny raport",
    expertConfirmFinalScore: "Wynik finalny",
    // ── Premium £4.99 expert reveal overlay (Session H40c) ──
    premiumExpertOverlayBadge: "Analiza premium zakończona",
    premiumExpertOverlayTitle: "Eksperci sprawdzili pełne dane",
    premiumExpertOverlaySub: "Aktualizujemy Twój Worthify Score na podstawie rejestrów…",
    premiumExpertOverlayScore: "Zaktualizowany wynik",
    premiumExpertOverlayDone: "Kliknij gdziekolwiek, aby zobaczyć raport",
    premiumExpertAnnaRisk: "Anna · Ekspert ds. ryzyka",
    premiumExpertEngine: "Marcus · Ekspert silnikowy",
    premiumExpertPlatform: "Iris · Ekspert platformy",
    premiumFindingWriteOff: "wykrył wpis o szkodzie całkowitej",
    premiumFindingTheft: "wykrył zgłoszenie kradzieży",
    premiumFindingMileage: "wykrył anomalię przebiegu",
    premiumFindingFinance: "wykrył niespłacone finansowanie",
    expertConfirmVerdictRefined: "Werdykt doprecyzowany pełnym konsensusem ekspertów",
    // Mobile dashboard (kafelki + modale)
    looksLike: "Wygląda na",
    worthifyScoreLabel: "Wynik Worthify",
    expectedCostShortLabel: "Przewidywany koszt",
    topRiskLabel: "Największe ryzyko",
    priceCheckLabel: "Ocena ceny",
    avgYearlyMiles: "Śr. mil / rok",
    totalMilesLabel: "Łączny przebieg",
    yearlyBreakdownTitle: "Podział roczny",
    scamDetectionLabel: "Wykrywanie oszustw",
    scamSafeValue: "Czysto",
    scamSafeBadge: "Brak alarmów",
    scamFlaggedBadge: "Zgłoszone",
    scamAllClearTitle: "Nie wykryto czerwonych flag",
    scamAllClearCopy: "Historia MOT i przebieg wyglądają spójnie.",
    scamChecklistTitle: "Co sprawdziliśmy",
    scamCheck1: "Spójność przebiegu między testami MOT",
    scamCheck2: "Historia niebezpiecznych usterek",
    scamCheck3: "Powtarzające się lub ignorowane usterki",
    scamCheck4: "Długie przerwy w MOT lub podejrzane wzorce",
    pdfReportValue: "Pobierz",
    pdfReportLabel: "Pełny raport PDF",
    pdfIncludesTitle: "Co znajdziesz w środku",
    whatThisMeans: "Co to oznacza",
    noMajorRisks: "Brak poważnych ryzyk",
    noPriceEvalCopy: "Podaj cenę docelową, aby uzyskać ocenę ceny.",
    safetyGoodCopy: "Bardzo dobre wyniki testów zderzeniowych jak na swoją generację.",
    safetyOkCopy: "Średnie wyniki testów zderzeniowych jak na swoją generację.",
    safetyPoorCopy: "Słabe wyniki testów zderzeniowych.",
    safetyNoDataCopy: "Brak oceny Euro NCAP dla tego modelu.",
    // 5-tier safety headlines + copies (one per Euro NCAP star)
    safetyHeadline5: "Najwyższe bezpieczeństwo",
    safetyHeadline4: "Wysokie bezpieczeństwo",
    safetyHeadline3: "Średnie bezpieczeństwo",
    safetyHeadline2: "Słabe bezpieczeństwo",
    safetyHeadline1: "Bardzo słabe bezpieczeństwo",
    safetyCopy5: "Najwyższy poziom ochrony — pełne 5★ Euro NCAP. Jeden z najbezpieczniejszych samochodów swojej generacji, z bardzo dobrą ochroną dorosłych, dzieci i pieszych.",
    safetyCopy4: "Wysoka ochrona w testach zderzeniowych — 4★ Euro NCAP. Solidna konstrukcja, która dobrze radzi sobie w nowoczesnych testach uderzeniowych.",
    safetyCopy3: "Średnia ochrona w testach zderzeniowych — 3★ Euro NCAP. Akceptowalna jak na swoją generację, ale nowsi rywale oferują wyraźnie lepszą ochronę pasażerów i pieszych.",
    safetyCopy2: "Słaba ochrona w testach zderzeniowych — 2★ Euro NCAP. Poniżej współczesnych standardów bezpieczeństwa, z wymiernym ryzykiem przy zderzeniach czołowych i bocznych.",
    safetyCopy1: "Bardzo słaba ochrona — 1★ Euro NCAP. Poważne obawy o bezpieczeństwo w realnych wypadkach; jeśli to możliwe, rozważ bezpieczniejszą alternatywę.",
    // Full safety breakdown — 4 Euro NCAP axes
    safetyBreakdownTitle: "Pełna analiza bezpieczeństwa",
    safetyBreakdownCopy: "Jak ten samochód wypada w czterech kategoriach testów Euro NCAP.",
    safetyAxisAdult: "Ochrona dorosłych",
    safetyAxisChild: "Ochrona dzieci",
    safetyAxisPedestrian: "Ochrona pieszych",
    safetyAxisAssist: "Systemy wspomagające",
    safetyBreakdownUnlockCta: "Odblokuj pełną analizę — £4.99",
    scoreExpertsUnlockCta: "Odblokuj pełną analizę ekspertów — £4.99",
    dangerousDefects: "niebezpiecznych usterek",
    downloadingPdf: "Pobieranie…",
    highRiskLabel: "WYSOKIE RYZYKO",
    mediumRiskLabel: "ŚREDNIE",
    lowRiskLabel: "NISKIE RYZYKO",
    unknownCause: "poważna awaria",
    // Mobilny dashboard v2 (wg reference)
    expectedCostShortTitle: "Spodziewane przyszłe wydatki",
    costSubtitleShort: "Realne koszty na najbliższe 12–24 miesiące.",
    // ExpectedCostCard hero (full-width reference design)
    expectedCostHeroTitle: "Spodziewane\nprzyszłe koszty",
    expectedCostBottomCaption: "Szacunkowy koszt w najbliższych 12–24 miesiącach",
    costTierLow: "Niskie",
    costTierModerate: "Umiarkowane",
    costTierHigh: "Wysokie",
    costTierClean: "Wygląda czysto",
    costDriversTitle: "Co generuje te koszty",
    safetyCardTitle: "Bezpieczeństwo (crash test)",
    safetyTileStrong: "Wysokie bezpieczeństwo – potwierdzone crash testami",
    safetyTileAverage: "Średnie bezpieczeństwo jak na swoją generację",
    safetyTilePoor: "Słabe wyniki testów zderzeniowych",
    safetyTileNoData: "Brak danych Euro NCAP",
    priceScamTitle: "Wykrywanie zawyżenia ceny",
    priceFair: "Cena wygląda uczciwie",
    priceOverpriced: "Cena wygląda wysoko",
    priceSuspicious: "Cena wygląda podejrzanie",
    priceSubtitleDetected: "Na bazie danych rynkowych i historii.",
    priceNoData: "Nie wykryto problemów z ceną",
    priceFairBig: "UCZCIWA CENA",
    priceOverpricedBig: "ZAWYŻONA",
    priceSuspiciousBig: "PODEJRZANA CENA",
    ourVerdictLabel: "Nasz werdykt",
    averageYearly: "Średnio rocznie",
    milesPerYear: "mil/rok",
    averageYearlyMileage: "Średni roczny przebieg",
    mileageConsistent: "Przebieg wygląda spójnie",
    mileageAnomalyCopy: "Wykryto anomalię przebiegu",
    mileageStableBadge: "STABILNE",
    mileageAnomalyBadge: "ANOMALIA",
    mileageTrend: "Trend przebiegu",
    mileageInsightTitle: "Wniosek o przebiegu",
    mileageInsightConsistent: "Przebieg jest spójny z wiekiem i historią auta.",
    mileageInsightAnomaly: "Progresja przebiegu ma niespójności. Sprawdź dokumentację serwisową.",
    dangerousDefectsHeadline: "Są niebezpieczne usterki",
    dangerousDefectsFound: "niebezpiecznych usterek",
    issuesFound: "wykrytych problemów",
    allClear: "Wszystko OK",
    riskSuffix: "RYZYKO",
    detectedTimesPrefix: "Wykryto",
    detectedTimesSuffix: "razy w historii MOT",
    estimatedCost: "Szacowany koszt",
    whyRiskTitle: "Dlaczego to ryzyko?",
    ifIgnoredTitle: "Jeśli zignorujesz, może to prowadzić do:",
    expertTipLabel: "Wskazówka eksperta",
    expertTipBody: "Zleć przegląd przed zakupem i zabudżetuj naprawę.",
    allDetectedIssues: "Wszystkie wykryte problemy",
    failedMotsLabel: "Nieudane MOT",
    viewFailedTests: "Zobacz testy",
    recurringIssuesLabel: "Powtarzające się",
    viewIssues: "Zobacz problemy",
    motHistoryLabel: "Historia MOT",
    viewHistory: "Zobacz historię",
    motHistoryTitle: "Historia MOT",
    failedMotsTitle: "Nieudane testy MOT",
    failedOnce: "nieudany test",
    failedPlural: "nieudanych testów",
    failedTestDetails: "Szczegóły nieudanych testów",
    noFailedDetails: "Brak szczegółowych danych o nieudanych testach.",
    recurringIssuesTitle: "Powtarzające się problemy",
    noRecurring: "W historii MOT nie znaleziono powtarzających się problemów.",
    seenIn: "Widziane w",
    testRecorded: "test zarejestrowany",
    testsRecorded: "testów zarejestrowanych",
    fullTimeline: "Pełna historia",
    noMotDetails: "Szczegółowa oś czasu MOT niedostępna.",
    pdfFullReportLabel: "Pełny raport",
    pdfUnlockTitle: "Odblokuj pełny raport",
    pdfUnlockCopy: "Pełna analiza, spostrzeżenia eksperta i analiza kosztów w PDF.",
    pdfUnlockCta: "Odblokuj za £4.99",
    pdfDownloadNow: "Pobierz pełny raport",
    dataSourcesTitle: "Sprawdzamy 50+ źródeł danych",
    dataSourcesCopy: "DVLA, MOT, ubezpieczenia, dane rynkowe i więcej",
    navOverview: "Podgląd",
    navVehicle: "Auto",
    navSearch: "Nowe auto",
    navReports: "Raporty",
    navMore: "Więcej",
    scoreBadgeGood: "DOBRE",
    scoreBadgeOk: "ŚREDNIE",
    scoreBadgeBad: "SŁABE",
    verifiedBy3Experts: "Potwierdzone przez 3 niezależnych ekspertów",
    whyThisScore: "Skąd ten wynik?",
    scoreScaleTitle: "Skala wyniku",
    scoreScaleExcellent: "Świetnie",
    scoreScaleGood: "Dobrze",
    scoreScaleAverage: "Średnio",
    scoreScalePoor: "Słabo",
    scoreScaleVeryPoor: "Bardzo słabo",
    scoreDisclaimer: "Wynik opiera się na dostępnych danych i nie jest gwarancją stanu pojazdu.",
    expertViewLabel: "Opinia eksperta",
    expectedCostModalTitle: "Spodziewane przyszłe koszty",
    expectedCostSubtitle: "Szacowany koszt w następnych 12–24 miesiącach",
    costBreakdownTitle: "Rozbicie kosztów",
    realisticRangeLabel: "Realny zakres",
    expertInsightLabel: "Wskazówka eksperta",
    expectedCostInsight: "Koszty są umiarkowane, ale powtarzające się usterki zwiększają ryzyko wyższych rachunków.",
    // Deterministic fallback paragraphs when AI summary is empty
    expectedCostFallbackDrivers: "Typowa ekspozycja kosztowa w 12–24 miesiące dla tego auta to około £{cost}, głównie z powodu: {drivers}.",
    expectedCostFallbackTopRisk: "Typowa ekspozycja kosztowa w 12–24 miesiące dla tego auta to około £{cost}, gdzie głównym problemem jest {issue}.",
    expectedCostFallbackGeneric: "Typowa ekspozycja kosztowa w 12–24 miesiące dla tego auta to około £{cost} na podstawie wieku, przebiegu i znanych usterek modelu.",
    expectedCostFallbackRange: "Realny zakres £{lo}–£{hi}; profilaktyczne serwisowanie zwykle utrzymuje koszty bliżej dolnej granicy.",
    useThisToNegotiate: "Użyj do negocjacji",
    testedIn: "Testowane w",
    miles: "mil",
    looksLikeA: "Wygląda na",
    verdictPrefixLow: "Wygląda na",
    verdictPrefixMedium: "Zachowaj",
    verdictPrefixHigh: "Lepiej tego",
    verdictMainMedium: "OSTROŻNOŚĆ",
    verdictShortGoodDeal: "DOBRA OKAZJA",
    verdictShortBeCautious: "UWAŻAJ",
    verdictShortAvoid: "UNIKAJ",
    heroFailedLabel: "NIEUDANE",
    heroMotSingular: "MOT",
    heroMotPlural: "MOT",
    // v3 additions (PL)
    seenInMotPrefix: "Potwierdzone z MOT",
    aiSuggested: "Sugerowane przez AI",
    motConfirmedBadge: "Potwierdzone z MOT",
    scoreShortGood: "Solidna historia — liczby potwierdzają pewny zakup.",
    scoreShortOk: "Sygnały mieszane — do przepracowania negocjacjami, ale uwaga na powtarzające się usterki.",
    scoreShortBad: "Wysokie ryzyko — zaplanuj dokładny przegląd przed zakupem.",
    totalRangeLabel: "Pełny zakres",
    pdfUnlockedLabel: "Odblokowane",
    pdfDownloadTitle: "Pobierz pełny raport",
    pdfDownloadCopy: "Twój pełny raport PDF jest gotowy.",
    unlockMoreDataLabel: "Odblokuj więcej danych",
    unlockMoreDataTitle: "Odblokuj 15 analiz premium",
    unlockMoreDataCopy: "Jednorazowa opłata 4,99 £ odblokowuje silnik, negocjacje, anomalie, właścicieli, wypadki, finansowanie, ULEZ, koszty utrzymania, utratę wartości i 6 innych sprawdzeń + pełny raport PDF.",
    fullPdfReport: "Pełny raport PDF",
    vehicleInformationTitle: "Informacje o pojeździe",
    vehicleSpecsTitle: "Specyfikacja",
    vehicleMakeLabel: "Marka",
    vehicleModelLabel: "Model",
    vehicleYearLabel: "Rok",
    vehicleEngineLabel: "Silnik",
    vehicleMileageLabel: "Przebieg",
    vehicleFuelLabel: "Paliwo",
    vehicleColourLabel: "Kolor",
    vehicleRegDateLabel: "Pierwsza rejestracja",
    vinVerifiedLabel: "VIN zweryfikowany",
    expertiseModalTitle: "Analiza eksperta",
    worthifyExpertName: "Ekspert Worthify",
    worthifyExpertRole: "Specjalista historii pojazdów · Konsensus 3 AI",
    expertVerifiedBadge: "Zweryfikowane",
    expertSummaryLabel: "Podsumowanie",
    engineCodeLabel: "Kod silnika",
    knownIssuesTitle: "Znane usterki silnika",
    yourLeverageTitle: "Twoja siła przetargowa",
    // NegotiationModal — premium real-data rebuild
    suggestedReductionKicker: "Proponowana obniżka",
    offAskingLabel: "od ceny oferowanej",
    expertLeverageTitle: "Ekspercka argumentacja",
    sellerScriptTitle: "Co powiedzieć sprzedającemu",
    copyPasteReadyLabel: "Skopiuj · wklej · wyślij",
    negoBulletTopRisk: "Główne ryzyko: {issue} — naprawa typowo £{lo}–£{hi}.",
    negoBulletKnownIssues: "Ten model ma {n} typowych słabych punktów — wspomnij o nich podczas oględzin.",
    negoBulletTopDocumented: "Udokumentowana usterka: {issue} — naprawa zwykle £{lo}–£{hi}.",
    negoBulletDocExposure: "Udokumentowana ekspozycja naprawcza: £{lo}–£{hi} na podstawie historii MOT tego auta.",
    negoStartMaxLine: "Zacznij od £{start} · maks. kupna £{max}",
    negoBulletTotalExposure: "Łączna ekspozycja naprawcza: £{lo}–£{hi} w ciągu kolejnych 24 miesięcy.",
    negoBulletComfortPrice: "Komfortowa oferta odzwierciedlająca to ryzyko to około £{price}.",
    negoEmptyCopy: "Nie wykryto mocnych argumentów negocjacyjnych — profil techniczny i rynkowy tego auta wygląda czysto. Stanowcza, ale uczciwa oferta w cenie wywoławczej (lub 2–3% poniżej) jest rozsądna.",
    // Scam-low listing warning (asking < 65% of real value)
    negoScamHeader: "Wykryto oszustwo",
    negoScamTitle: "Nie negocjuj — odejdź od transakcji",
    negoScamCopy: "Cena oferowana (£{asking}) jest dużo poniżej realnej wartości rynkowej tego auta (£{value}). Taki schemat prawie zawsze oznacza fikcyjne ogłoszenie, kradzione auto, ukryte szkody lub oszustwo escrow. Nie wpłacaj zaliczki, nie udostępniaj dokumentów ani nie organizuj transportu. Zgłoś ogłoszenie i odpuść.",
    negoScamBullet1: "Zweryfikuj tożsamość sprzedającego osobiście przed jakąkolwiek płatnością",
    negoScamBullet2: "Wykonaj sprawdzenie DVLA / pełnej historii na VIN przed przelewem środków",
    negoScamBullet3: "Odrzuć każdą prośbę o crypto / gift card / przelew SWIFT",
    // VIN mismatch scam variants
    negoScamVinTitle: "VIN nie zgadza się z rejestracją — odejdź",
    negoScamVinCopy: "VIN sprzedającego dekoduje się jako {vinMake} {vinYear}, ale rejestracja DVLA pokazuje {dvlaMake} {dvlaYear}. To podręcznikowy sygnał klonowanego auta / VIN-swap. Nie wpłacaj zaliczki ani nie udostępniaj dokumentów.",
    // Score modal scam banner
    scoreScamHeader: "Wykryto oszustwo",
    scoreScamPriceTitle: "Cena oferowana znacznie poniżej wartości rynkowej",
    scoreScamPriceCopy: "Cena oferowana jest znacznie poniżej realnej wartości rynkowej tego auta. Prawie zawsze oznacza to fikcyjne ogłoszenie, kradzione auto lub oszustwo escrow — wynik wymuszony na 25/100 (AVOID).",
    scoreScamVinTitle: "VIN nie zgadza się z rejestracją",
    scoreScamVinCopy: "VIN sprzedającego dekoduje się jako inna marka lub rok niż rejestracja DVLA. Ten schemat sygnalizuje klonowane auto lub VIN-swap — wynik wymuszony na 25/100 (AVOID).",
    noAnomalies: "Nie wykryto anomalii w historii MOT.",
    flaggedAnomalies: "Oznaczone anomalie",
    lockedPremiumTitle: "Sekcja premium",
    lockedPremiumCopy: "Odblokuj tę sekcję wraz z pełnym raportem PDF i 14 innymi analizami premium za 4,99 £.",
    premiumAnalysesTitle: "Wszystkie analizy",
    moreLockedHeadline: "3 analizy premium zablokowane",
    premiumLockedTag: "Premium · Zablokowane",
    premiumUnlockedTag: "Premium · Odblokowane",
    newSearchTitle: "Nowe auto do sprawdzenia",
    newSearchCopy: "Rozpocznij analizę innej rejestracji. Obecna analiza zostanie zachowana.",
    currentRegLabel: "Obecne",
    checkNewCarCta: "Sprawdź nowe auto",
    cancelLabel: "Anuluj",
    swipeDownHint: "Wskazówka: przesuń palcem w dół, aby zamknąć",
    registrationLabel: "Rejestracja",
    regPlaceholder: "np. AB12CDE",
    vinOptionalHint: "Opcjonalne · 17 znaków · zwiększa dokładność",
    priceOptionalHint: "Opcjonalne · odblokowuje sprawdzenie ceny",
    newSearchPaymentTitle: "Nowa analiza wymaga nowej płatności",
    newSearchPaymentCopy: "Każde sprawdzenie pojazdu to jednorazowa płatność 1 £, która odblokowuje wszystkie analizy premium dla tego auta.",
    checkNewCarForOnePound: "Sprawdź nowe auto za 1,00 £",
    vinInvalidLength: "VIN musi mieć dokładnie 17 znaków",
    vinInvalidChars: "VIN może zawierać tylko litery i cyfry",
    addVinBadge: "Darmowe ulepszenie",
    addVinTitle: "Sprawdź czy VIN pasuje do rejestracji",
    addVinCopy: "Wykryj sklonowane auto lub VIN-swap w kilka sekund. Porównujemy Twój VIN z marką i rokiem z DVLA — natychmiast, za darmo, bez dodatkowej opłaty.",
    addVinCta: "Dodaj VIN teraz",
    shareWithMechanicBadge: "Druga opinia",
    shareWithMechanicTitle: "Wyślij raport mechanikowi",
    shareWithMechanicCopy: "Wyślij rejestrację zaufanemu mechanikowi lub znajomemu. Otrzyma link jednym kliknięciem, aby zweryfikować wyniki przed zakupem auta.",
    shareWithMechanicCta: "Udostępnij link",
    shareWithMechanicMessage: "Hej — co myślisz o tym aucie? Worthify zrobił dla mnie analizę:",
    shareWithMechanicCopied: "Link skopiowany — wklej go mechanikowi",
    shareWithMechanicCopyError: "Nie udało się skopiować. Przytrzymaj, aby udostępnić ręcznie.",
    marketGauge_UNDERPRICED: "Poniżej rynku",
    marketGauge_FAIR: "Cena uczciwa",
    marketGauge_SLIGHTLY_OVER: "Lekko zawyżona",
    marketGauge_SIGNIFICANTLY_OVER: "Znacznie zawyżona",
    marketGaugeAskingLabel: "Cena oferty",
    marketGaugeMarketLabel: "Rynek",
    recurringIgnoredBadge: "Ignorowane wielokrotnie",
    recurringIssuesTimelineTitle: "Oś czasu nawracających usterek",
    negotiationHeadline: "Cel negocjacji",
    negotiationItemTarget: "Sugerowana zniżka",
    negotiationCumulativeLabel: "Łączna oszczędność dla kupującego",
    betaDataBannerTitle: "Dane beta — pełna wersja wkrótce",
    betaDataBannerBody: "Ten moduł używa obecnie szacunków heurystycznych na podstawie profilu pojazdu. Integracja z prawdziwymi danymi pojawi się w kolejnej aktualizacji.",
    addVinBadgeLowConf: "Popraw dokładność",
    addVinTitleLowConf: "Dodaj VIN dla precyzyjniejszej wyceny",
    addVinCopyLowConf: "To nowy / niszowy model — publiczne dane cenowe są ograniczone. Podanie VIN pozwala określić dokładną wersję, cenę katalogową i realną wartość rezydualną.",
    addVinModalTitle: "Zweryfikuj VIN",
    addVinModalCopy: "Wpisz 17-znakowy VIN od sprzedającego (książka V5C lub tabliczka pod szybą). Porównamy go z marką i rokiem z DVLA — jeśli nie pasuje, wynik zostanie wymuszony na AVOID.",
    addVinSubmit: "Zweryfikuj VIN teraz",
    addVinChecking: "Sprawdzam VIN…",
    addVinDone: "Gotowe",
    addVinError: "Nie udało się zweryfikować VIN. Spróbuj ponownie.",
    addVinScamTitle: "Wykryto niezgodność VIN — możliwe sklonowane auto",
    addVinScamCopy: "Wynik został wymuszony na AVOID. Zobacz czerwony baner na dashboardzie.",
    addVinOkTitle: "VIN zweryfikowany — marka i rok zgadzają się",
    addVinOkCopy: "Brak sygnałów klonowania. Dashboard pokazuje teraz odznakę weryfikacji.",
    addVinUndecodableTitle: "VIN zapisany — nie udało się zdekodować publicznie",
    addVinUndecodableCopy: "Amerykańska publiczna baza danych nie zawiera tego VIN-u. Częste dla modeli sprzedawanych tylko w UK — to nie jest sygnał alarmowy.",
    vinUndecodableNote: "Twój VIN został zapisany, ale nie udało się go zdekodować w publicznej bazie USA. Wiele modeli sprzedawanych tylko w UK tam nie ma — to nie jest sygnał alarmowy.",
    vinVerifiedBadge: "VIN zweryfikowany",
    vinVerifiedCopy: "VIN sprzedającego zgadza się z marką i rokiem z DVLA. Brak sygnałów klonowania.",
    // ─── Legal pages ─────────────────────────────────────────────────
    legalNavTerms: "Regulamin",
    legalNavPrivacy: "Polityka prywatności",
    legalNavCookies: "Polityka cookies",
    legalNavAccessibility: "Dostępność",
    legalBackToHome: "Wróć do Worthify",
    legalLastUpdated: "Ostatnia aktualizacja",
    legalAllRights: "Wszelkie prawa zastrzeżone.",
    // ─── Trust strip & methodology ───────────────────────────────────
    trustVerifiedBy: "Zweryfikowane przez",
    trustJustNow: "przed chwilą",
    trustMinutesAgo: "{n} min temu",
    trustHoursAgo: "{n} godz. temu",
    trustDaysAgo: "{n} dzień temu",
    trustAisAgreed: "AI zgodziło się",
    trustHowItWorks: "Jak to działa",
    methodologyTitle: "Jak działa Worthify",
    methodologyIntro: "Worthify łączy publiczne dane rządowe UK z konsensusem 3 modeli AI, aby oszacować ryzyko zakupu konkretnego używanego samochodu. Poniżej dokładnie skąd pochodzi każda informacja.",
    methodologySourcesTitle: "Źródła danych",
    sourceDvsaDesc: "Oficjalna agencja rządowa UK — każdy wynik badania MOT, ostrzeżenia i defekty.",
    sourceNhtsaDesc: "Publiczna baza rządowa USA używana do dekodowania VIN sprzedającego i wykrywania sklonowanych aut.",
    sourceAiDesc: "Trzy niezależne duże modele językowe analizują dane równolegle. Worthify Score używa mediany ich estymacji, aby pojedyncza halucynacja AI nie wypaczyła wyniku.",
    methodologyConfidence: "Pewność: {level}",
    confidenceHigh: "Wysoka",
    confidenceMedium: "Średnia",
    confidenceLow: "Niska",
    methodologyConfHighHint: "Historia MOT, VIN i przebieg — wszystko obecne. Zgodność wielu AI w wynikach.",
    methodologyConfMedHint: "Brakuje niektórych danych (np. VIN lub pełnej historii MOT). Wynik jest wiarygodny, ale nie maksymalny.",
    methodologyConfLowHint: "Ograniczone dane publiczne dla tego pojazdu. Wynik to heurystyka — zdecydowanie zalecamy inspekcję fizyczną.",
    methodologyDisclaimerTitle: "Niezależna inspekcja nadal zalecana",
    methodologyDisclaimer: "Worthify łączy oficjalne dane DVSA, DVLA i NHTSA z silnikiem konsensusu 3-AI — dając Ci prawdziwe More Than HPI Check w ułamku ceny. Nie zastępuje fizycznej oceny pojazdu. Zawsze umów własną inspekcję mechaniczną przed zakupem.",
    dashboardAiDisclaimer: "To nie jest inspekcja mechaniczna. Zawsze przeprowadź własną inspekcję mechaniczną przed zakupem.",
    // ─── Pre-checkout consent modal (UK Consumer Contracts Regs 2013) ─
    preCheckoutBadge: "Potwierdź zakup",
    preCheckoutVerdictProductName: "Worthify Basic Verdict",
    preCheckoutPdfProductName: "Premium Worthify Report (PDF + 15 modułów)",
    preCheckoutTotal: "Razem",
    preCheckoutOneTime: "Płatność jednorazowa",
    preCheckoutNoSub: "Brak subskrypcji · Brak automatycznego odnawiania",
    preCheckoutWarningTitle: "Natychmiastowa dostawa cyfrowa",
    preCheckoutWarningBody: "Raport zostanie dostarczony natychmiast w Twojej przeglądarce w momencie płatności. Potwierdzając zgadzasz się na natychmiastowe rozpoczęcie świadczenia usługi i rezygnujesz z 14-dniowego prawa odstąpienia zgodnie z UK Consumer Contracts Regulations 2013.",
    preCheckoutConsent: "Zgadzam się na natychmiastową dostawę i rozumiem, że tracę 14-dniowe prawo odstąpienia.",
    preCheckoutPayCta: "Zapłać £{n} przez Stripe",
    preCheckoutRedirecting: "Przekierowuję do Stripe…",
    preCheckoutTrustLine: "Zabezpieczone przez Stripe · Dane karty nigdy nie trafiają do Worthify · Paragon wysyłany automatycznie",
    paymentTimeoutError: "Płatność trwa dłużej niż zwykle. Jeśli Twoja karta została obciążona, skontaktuj się z support@worthify.co.uk podając ID sesji: ",
    premiumAnalysesBadge: "Analizy premium",
    ownersModalTitle: "Poprzedni właściciele",
    ownerSingular: "zarejestrowany właściciel",
    ownerPlural: "zarejestrowanych właścicieli",
    ownersTimelineTitle: "Oś czasu własności",
    ownerLabel: "Właściciel",
    ownersInsightTitle: "Wskazówka",
    ownersFewCopy: "Niewielu właścicieli — zwykle oznacza, że auto było dobrze utrzymane.",
    ownersAverageCopy: "Średnia liczba właścicieli — brak sygnałów ostrzegawczych, ale poproś o historię serwisową.",
    ownersManyCopy: "Wielu właścicieli w krótkim czasie może wskazywać na problemy — sprawdź uważnie.",
    ownersCountLabel: "Łącznie właścicieli",
    lastChangeLabel: "Ostatnia zmiana",
    accidentModalTitle: "Historia wypadków",
    accidentRiskHigh: "Możliwa historia uszkodzeń",
    accidentRiskLow: "Brak oznak wypadków",
    accidentScopeLabel: "Na podstawie kontroli strukturalnych MOT",
    accidentChecksTitle: "Co sprawdziliśmy",
    accidentCheck1: "Uszkodzenia podwozia / strukturalne w historii MOT",
    accidentCheck2: "Niesprawności układu kierowniczego i zawieszenia",
    accidentCheck3: "Wpisy o głównych naprawach karoserii w stacjach kontroli",
    accidentCheck4: "Zgodność z rejestrami wypadków branżowych",
    structuralFlagsLabel: "Oznaki strukturalne",
    damageHistoryLabel: "Historia uszkodzeń",
    writeOffModalTitle: "Sprawdzenie kasacji",
    writeOffFlagged: "Wymagane sprawdzenie",
    writeOffClean: "Brak wpisu o kasacji",
    writeOffScope: "Cat S · Cat N · Cat A · Cat B",
    writeOffCategoriesTitle: "Kontrola kategorii",
    writeOffCatA: "Tylko złom",
    writeOffCatB: "Na części",
    writeOffCatS: "Uszkodzenia strukturalne",
    writeOffCatN: "Niestrukturalne",
    financeModalTitle: "Aktywne finansowanie",
    financeFound: "Aktywne finansowanie",
    financeClean: "Brak aktywnego finansowania",
    financeFoundCopy: "Ten pojazd ma aktywne finansowanie — nie może zostać legalnie sprzedany do czasu jego uregulowania. Odejdź, dopóki sprzedawca nie pokaże potwierdzenia spłaty.",
    financeCleanCopy: "Nie wykryto aktywnego kredytu, leasingu ani umowy HP na tym pojeździe. Możesz bezpiecznie kontynuować.",
    financeContextTitle: "Kontekst",
    financeContextCopy: "Przy wycenie około {value}, auta z aktywnym finansowaniem biorą udział w ~5% sporów w sprzedaży prywatnej w UK. Ten pojazd jest czysty.",
    financeStatusLabel: "Status finansowania",
    premiumAnalysesLocked: "analiz premium zablokowanych",
    // ─── ULEZ / Clean Air ───
    ulezModalTitle: "ULEZ / Strefa czysta",
    ulezStatusLabel: "Status ULEZ",
    euroClassLabel: "Klasa Euro",
    ulezCompliantTitle: "Zgodny z ULEZ",
    ulezNonCompliantTitle: "Niezgodny z ULEZ",
    ulezChargesTitle: "Opłata dzienna w UK",
    govUkDisclaimer: "Szacunek na podstawie roku i paliwa. Sprawdź na gov.uk/check-clean-air-zone-charge",
    // ─── Running costs ───
    runningCostsModalTitle: "Koszty utrzymania",
    annualCostLabel: "Roczny koszt",
    monthlyCostLabel: "Miesięcznie",
    perYear: "rocznie",
    perMonth: "miesięcznie",
    assumedMiles: "zakładane 10 tys. mil/rok",
    costBreakdownTitle: "Podział kosztów",
    costFuel: "Paliwo",
    costTax: "Podatek drogowy",
    costInsurance: "Ubezpieczenie",
    costService: "Serwis",
    runningCostsDisclaimer: "Szacunki na podstawie średnich UK. Rzeczywiste koszty różnią się w zależności od stylu jazdy, lokalizacji i ubezpieczyciela.",
    // ─── Depreciation ───
    depreciationModalTitle: "Prognoza utraty wartości",
    valueIn3Label: "Wartość za 3 lata",
    valueIn5Label: "Wartość za 5 lat",
    currentValueLabel: "Obecna wartość",
    nowLabel: "Teraz",
    forecastTableTitle: "Prognoza",
    inLabel: "Za",
    yearLabel: "rok",
    yearsLabel: "lat",
    // ─── Theft ───
    theftModalTitle: "Sprawdzenie kradzieży",
    policeRegisterLabel: "Rejestr policji",
    dvlaRecordLabel: "Rejestr DVLA",
    theftFlagged: "Zgłoszony jako skradziony",
    theftClean: "Brak wpisu o kradzieży",
    theftFlaggedCopy: "Ten pojazd jest zarejestrowany jako skradziony. NIE kontynuuj — skontaktuj się z policją pod numerem 101.",
    theftCleanCopy: "Brak wpisu w Policyjnym Komputerze Narodowym ani w rejestrze kradzieży DVLA. Ten pojazd wygląda na legalny.",
    theftChecksTitle: "Sprawdzone rejestry",
    theftCheck1: "Policyjny Komputer Narodowy (PNC)",
    theftCheck2: "Rejestr kradzieży DVLA",
    theftCheck3: "MIAFTR (branża ubezpieczeniowa)",
    theftCheck4: "Porty / flagi importowe",
    // ─── Import ───
    importModalTitle: "Historia importu",
    originLabel: "Pochodzenie",
    importTypeLabel: "Typ importu",
    importDetected: "Wykryto import",
    noImportFlag: "Rynek UK / EU",
    fromCountryLabel: "Kraj",
    typeLabel: "Typ",
    importImpactTitle: "Co to oznacza",
    importImpactCopy: "Importowane auta mogą być trudniejsze do ubezpieczenia i mieć wolniejszą dostępność części. Sprawdź V5C pod kątem daty rejestracji w UK oraz certyfikatu NOVA (Notification of Vehicle Arrival).",
    noVinForImport: "Dodaj VIN na stronie głównej, aby uzyskać pełne sprawdzenie kraju pochodzenia.",
    // ─── Insurance group ───
    insuranceGroupModalTitle: "Grupa ubezpieczeniowa",
    abiGroupLabel: "Grupa ABI",
    premiumRangeLabel: "Typowa składka",
    outOfLabel: "z",
    premiumEstimateTitle: "Roczna szacunkowa składka",
    perYearLabel: "rocznie",
    basedOn30yoLabel: "kierowca 30 lat, 5 lat bez szkód",
    insuranceDisclaimer: "Szacunkowa grupa. Twoja składka zależy od wieku, kodu pocztowego, historii szkód i udziału własnego.",
    // ─── Tyre & brake ───
    tyreBrakeModalTitle: "Zużycie opon i hamulców",
    tyresLabel: "Opony",
    brakesLabel: "Hamulce",
    lifeRemaining: "pozostało",
    wearWarningTitle: "Zabudżetuj wymianę",
    wearBothCopy: "Historia MOT pokazuje wielokrotne usterki opon I hamulców. Zabudżetuj 600+ £ na wymianę w pierwszych 6 miesiącach.",
    wearTyreCopy: "Historia MOT sygnalizuje zużycie opon. Zabudżetuj 300-500 £ na komplet 4 opon.",
    wearBrakeCopy: "Historia MOT sygnalizuje zużycie hamulców. Zabudżetuj 200-400 £ na wymianę klocków/tarcz.",
    // ─── Similar sold ───
    similarSoldModalTitle: "Podobne sprzedane",
    averageSoldLabel: "Śr. cena sprzedaży",
    avgDaysLabel: "Śr. dni do sprzedaży",
    basedOnLastNSales: "Na podstawie 5 ostatnich sprzedaży",
    avgDaysOnMarket: "śr. dni na rynku",
    recentSalesTitle: "Ostatnie porównywalne sprzedaże",
    daysToSell: "dni do sprzedaży",
    similarSoldDisclaimer: "Ceny z ogłoszeń UK dla tego samego modelu, marki i rocznika.",
    helpHeroKicker: "3 niezależnych ekspertów",
    helpHeroTitle: "Oceniamy historię tego pojazdu",
    helpUnlockHero: "Odblokuj pełny obraz",
    helpUnlockSub: "Silnik · Negocjacje · Anomalie · Finansowanie · PDF",
    helpDownloadHero: "Pobierz pełny raport",
    helpDownloadSub: "Analizy premium + PDF — już opłacone",
    // ─── WhatYouGet trust modal (pre-Stripe) ───
    whatYouGetTitle: "Co otrzymasz",
    whatYouGetKicker: "Premium odblokowanie — 4,99 £",
    whatYouGetHeadline: "15 analiz premium + pełny PDF",
    socialProofCopy: "Używane przez 50 000+ kupujących w UK",
    includedTitle: "Wszystko, co jest wliczone",
    benefitEngine: "Analiza silnika i znane problemy",
    benefitNegotiation: "Taktyki negocjacyjne",
    benefitAccident: "Sprawdzenie wypadków i kasacji",
    benefitFinance: "Sprawdzenie aktywnego finansowania",
    benefitUlez: "ULEZ + 5-letnie koszty utrzymania",
    benefitDepreciation: "Prognoza utraty wartości",
    benefitSimilar: "Podobne sprzedane auta (ostatnie 5)",
    benefitPdf: "Pełny raport PDF do druku",
    trustSecure: "Zabezpieczone Stripe",
    trustInstant: "Natychmiastowy dostęp",
    trustGdpr: "Zgodne z GDPR",
    proceedToPaymentCta: "Przejdź do płatności — 4,99 £",
    maybeLaterCta: "Może później",
    // ─── Premium Home view + nav ───
    navPremium: "Premium",
    premiumHomeKicker: "Premium · Odblokowane",
    premiumHomeTitle: "Wszystkie 15 analiz premium",
    premiumHomeCopy: "Kliknij dowolny kafelek, aby zobaczyć pełną analizę. Kliknij Przegląd, aby wrócić do głównego dashboardu.",
    premiumHomeFooter: "Kliknij Przegląd poniżej, aby wrócić do głównego dashboardu",
    premiumLabel: "Premium",
    independentBadge: "Niezależny",
    helpModalTitle: "Jak działa Worthify",
    helpSection1Title: "Twój werdykt",
    helpSection1Copy: "Karta główna pokazuje werdykt oparty na ocenie 3 niezależnych ekspertów analizujących historię tego pojazdu.",
    helpSection2Title: "Eksploruj każdy kafelek",
    helpSection2Copy: "Dotknij dowolny kafelek, aby otworzyć pełen modal ze szczegółami, grafiką i wskazówkami. Przesuń w lewo/prawo, aby nawigować.",
    helpSection3Title: "Odblokuj wszystko",
    helpSection3Copy: "Jedna płatność 4,99 £ odblokowuje analizę silnika, siłę negocjacyjną, sprawdzenie anomalii, ukrytego ryzyka finansowania i pełny raport PDF.",
    engineAnalysisShort: "Usterki silnika",
    viewEngine: "Zobacz silnik",
    negotiationShort: "Negocjacje",
    viewNegotiation: "Negocjuj",
    anomaliesShort: "Anomalie",
    viewAnomalies: "Zobacz anomalie",
    navExpertise: "Ekspert",

    // Dashboard – dodatkowe etykiety (DVLA / V5C / ULEZ / Wnioski ekspertów)
    motExpiryLabel: "MOT wygasa",
    v5cIssuedLabel: "Ostatni V5C",
    seeFullExpertAnalysis: "Zobacz pełną analizę ekspertów",
    confidenceLabelHigh: "Wysoka pewność",
    confidenceLabelMedium: "Średnia pewność",
    confidenceLabelLow: "Niska pewność",
    leverageLabel: "Argument",
    rangeLabel: "zakres",
    marketGaugeVsMarket: "względem rynku",
    severityDangerous: "Niebezpieczna",
    severityFailure: "Niezdana",
    severityMajor: "Poważna",
    severityMinor: "Drobna",
    severityAdvisory: "Doradcza",
    severityNote: "Uwaga",
    recurringAcross: "w",
    recurringYearsLabel: "latach",
    yearSingular: "rok",
    yearPlural: "lat",
    copyNegotiationCta: "Skopiuj argumenty do negocjacji",
    copyNegotiationAria: "Skopiuj argumenty do negocjacji do schowka",
    copyNegoTitle: "Worthify – argumenty do negocjacji",
    copyNegoTotalLabel: "Cel łącznie",
    copyNegoRangeLabel: "Zakres",
    copyNegoSourceLabel: "Źródło",
    copyNegoSuccess: "Skopiowano — wklej w WhatsApp lub SMS",
    copyNegoError: "Kopiowanie nie powiodło się — spróbuj ponownie",

    // Modal "Proste wytłumaczenie" (uniwersalne, dla wszystkich poziomów)
    simpleExplanationTitle: "Proste wytłumaczenie",
    simpleExplanationKicker: "Po ludzku",
    simpleExplanationHeadline: "Czy mam to kupić?",
    simpleExplanationSubhead: "Bez żargonu — uczciwa odpowiedź na podstawie pełnej analizy Worthify, napisana tak, by każdy zrozumiał.",
    simpleExplanationVerdictTitle: "O co tu chodzi",
    simpleExplanationEmpty: "Analiza wciąż jest przygotowywana. Spróbuj za chwilę.",
    simpleExplanationDisclaimer: "To streszczenie ma charakter informacyjny — przed zakupem zawsze zleć inspekcję mechaniczną u zaufanego mechanika.",
    simpleExplanationCardTitle: "Czy mam to kupić?",
    simpleExplanationCardSub: "60-sekundowa odpowiedź, którą każdy zrozumie",
    simpleExplanationLockedTitle: "Pełne wytłumaczenie",
    simpleExplanationLockedBadge: "Zablokowane — odblokuj w Premium",
    simpleExplanationUnlockCta: "Odblokuj pełne wytłumaczenie — Premium",
    unlockItemSimpleExplanation: "Proste streszczenie kupić/odpuścić",

    // Etykiety motywów usterek MOT (używane w Top Risk / lista wykrytych usterek)
    defectThemeOilLeak: "Wyciek oleju / nieszczelność uszczelnienia",
    defectThemeBrakes: "Zużycie elementów hamulcowych",
    defectThemeTyres: "Zużycie / stan opon",
    defectThemeSteering: "Zużycie połączeń układu kierowniczego",
    defectThemeSuspension: "Zużycie elementów zawieszenia",
    defectThemeEmissions: "Problem z układem emisji spalin",
    defectThemeLights: "Usterka oświetlenia",
    defectThemeExhaust: "Zużycie układu wydechowego",
    defectThemeElectrical: "Usterka elektryczna / ładowania",
    defectThemeCorrosion: "Korozja / zużycie konstrukcyjne",
    defectThemeWipers: "Wycieraczki / spryskiwacze",
    defectThemeSeatbelt: "Kontrola pasów / mocowań",
    defectThemeScreen: "Szyba przednia",
    defectRecurringSuffix: "Powraca w MOT — nie naprawione, może się pogłębiać.",
    expertsCountBadge: "3 ekspertów",
    expertiseLockedMore: "więcej w Premium",
    expertDeepAnalysisTitle: "Wnioski poszczególnych ekspertów",
    expertNoFindings: "Ten ekspert nie zgłosił żadnych istotnych uwag.",
    co2Label: "CO₂",
    dataSourceDvla: "Źródło: DVLA VES",
    vehicleCo2Label: "Emisja CO₂",
    vehicleEuroLabel: "Norma Euro",
    vehicleTypeApprovalLabel: "Homologacja",
    vehicleUlezLabel: "ULEZ",
    vehicleV5CLabel: "Ostatni V5C",
    vehicleMarkedForExportLabel: "Zgłoszony na eksport",
    ulezCompliantShort: "Spełnia",
    ulezNonCompliantShort: "Opłata",
    ulezVerifyShort: "Sprawdź w TfL",
    ulezVerifyOnTfl: "Sprawdź w TfL — oficjalny weryfikator",
    ulezUnknownTitle: "Status ULEZ niepotwierdzony",
    ulezUnknownNote: "DVLA nie zwróciło normy Euro dla tej rejestracji. Starsze diesle bywają modernizowane, a tablice spersonalizowane mogą maskować nowszy pojazd Euro 6 — sprawdź w oficjalnym weryfikatorze TfL poniżej.",
    ownersV5CLabel: "Ostatni V5C wystawiony",
    ownersV5CFreshNote: "Wystawiony w ciągu ostatnich 12 miesięcy — zwykle oznacza niedawną zmianę właściciela (DVLA).",
    ownersV5COldNote: "Ten sam dokument V5C nadal aktywny — brak niedawnej zarejestrowanej zmiany właściciela.",
    riskLevel_HIGH: "WYSOKIE",
    riskLevel_MEDIUM: "ŚREDNIE",
    riskLevel_LOW: "NISKIE",
    errorInvalidPlateChars: "W brytyjskich tablicach dozwolone są tylko litery i cyfry.",
    legalEnNotice: "Ten dokument prawny jest dostępny po angielsku. Usługa Worthify jest świadczona z Wielkiej Brytanii i podlega prawu brytyjskiemu. W razie pytań napisz na support@worthify.co.uk.",
    ninaButtonLabel: "Zapytaj Ninę — Powered by Pine",
    ninaHeaderTitle: "Nina — Twój Co-Pilot przy zakupie auta",
    poweredByPine: "Powered by Pine",
    ninaGreeting: "Cześć! Przeczytałam raport dla {reg}. Chcesz wiedzieć czy warto kupić to auto? Po prostu zapytaj.",
    ninaGreetingWorthifyAsk: "Cześć! Sprawdziłam raport dla {reg}. Według wartości Worthify możesz wynegocjować cenę niżej o {saving} — z {asking} do {target}. Chcesz żebym to załatwiła za Ciebie? Kliknij Call poniżej.",
    ninaGreetingWorthifyMarket: "Cześć! Sprawdziłam raport dla {reg}. Według wartości Worthify możesz wynegocjować cenę do około {target} ({saving} poniżej rynku). Chcesz żebym to załatwiła za Ciebie? Kliknij Call poniżej.",
    ninaInputPlaceholder: "Zapytaj Ninę o cokolwiek…",
    ninaCallPitch: "Chcesz, żebym zadzwoniła do sprzedawcy i negocjowała cenę?",
    ninaCallSellerCta: "Zadzwoń do sprzedawcy — £2.99",
    ninaCalling: "Nina dzwoni do sprzedawcy…",
    ninaCallDone: "Rozmowa zakończona",
    ninaCallFailed: "Rozmowa nieudana",
    ninaCallFailedHint: "Sprzedawca nie odebrał lub połączenie nie zostało nawiązane. Nie zostałeś obciążony.",
    ninaCallTimeout: "Przekroczono czas rozmowy — spróbuj ponownie.",
    backGuardToast: "Przesuń wstecz jeszcze raz, aby opuścić raport",
    heroVehicleTypes: "Auta · Motocykle · Vany · Ciężarówki — każda brytyjska rejestracja",
    vehicleCategoryMotorcycle: "Motocykl",
    ninaCounterOfferTitle: "Kontroferta sprzedawcy",
    ninaCounterOfferBody: "Nina powiedziała sprzedawcy, że się zastanowisz — oferta wciąż jest aktualna. Zaakceptuj, a Nina oddzwoni i potwierdzi, albo ją odrzuć.",
    ninaCounterAboveMax: "{diff} powyżej Twojego maks. budżetu",
    ninaCounterAcceptCta: "Akceptuję {price} — Nina potwierdza",
    ninaCounterRejectCta: "Odrzuć kontrofertę",
    ninaRecalling: "Nina oddzwania do sprzedawcy, aby potwierdzić transakcję…",
    ninaCounterRejectedMsg: "Jasne — odrzuciłam kontrofertę. Sprzedawca wie, że rezygnujesz, jeśli cena się nie poprawi. Możesz dalej pytać mnie o cokolwiek.",
    ninaCallTranscriptToggle: "Pokaż transkrypt",
    ninaCallMockSummary: "Sprzedawca rozważy £5,700 (z £6,000). Prosi o telefon wieczorem aby potwierdzić.",
    // Modal danych sprzedawcy (Etap 3)
    ninaCallSellerTitle: "Nina dzwoni do sprzedawcy",
    ninaCallSellerSubtitle: "Nina zadzwoni do sprzedawcy, wynegocjuje cenę na podstawie Twojego raportu i prześle pełny transkrypt. £2.99 jednorazowo.",
    ninaSellerNameLabel: "Imię sprzedawcy (jeśli znane)",
    ninaSellerNamePlaceholder: "np. James",
    ninaSellerPhoneLabel: "Numer UK sprzedawcy *",
    ninaInvalidPhone: "Wpisz prawidłowy numer UK (np. 07xxx xxxxxx)",
    ninaTargetPriceLabel: "Cel £",
    ninaMaxPriceLabel: "Maks. £",
    ninaAnchorAsking: "ceny ofertowej",
    ninaAnchorMarket: "wartości rynkowej",
    ninaTargetHint: "💡 Sugerujemy {amt} · {pct}% poniżej {anchor}",
    ninaTargetHintAt: "💡 Sugerujemy {amt} · odpowiada {anchor}",
    ninaMaxHint: "🛑 Górna granica {amt} · {pct}% poniżej {anchor}",
    ninaMaxHintAbove: "🛑 Górna granica {amt} · {pct}% powyżej {anchor}",
    ninaWorthifySuggestionKicker: "Worthify sugeruje",
    ninaWorthifyDelta: "{pct}% poniżej {anchor}",
    ninaWorthifyRationale: "Na podstawie udokumentowanych usterek MOT, szacowanych kosztów napraw i danych rynkowych. Największa szansa na udaną negocjację.",
    ninaMaxBudgetLabel: "Twój maks. budżet £",
    ninaBudgetHelper: "Podając WYŻSZĄ kwotę niż sugerowana zwiększasz szanse na wygraną negocjację. Podając kwotę NIŻSZĄ zmniejszasz prawdopodobieństwo wygranej — ale zostajesz w swoim budżecie.",
    ninaBudgetMatch: "🎯 Zgodne z Worthify — największa szansa na udaną negocjację.",
    ninaBudgetAbove: "✅ Powyżej Worthify — Nina zaczyna od {wfy}, dochodzi do Twojej {max} tylko gdy sprzedawca odmówi. Wysoka szansa sukcesu.",
    ninaBudgetBelow: "⚠️ Poniżej Worthify — Nina zaczyna od Twojej {max}, dochodzi do {wfy} tylko w ostateczności. Mniejsza szansa, ale w Twoim budżecie.",
    ninaCallNowSingleCta: "Zapłać £2,99 · Zadzwoń i negocjuj za {amt}",
    ninaCallNowRangeCta: "Zapłać £2,99 · Zadzwoń · {tgt} → {max}",
    ninaCallLegalNote: "Klikając dalej potwierdzasz, że masz podstawę prawną aby zadzwonić pod ten numer. Rozmowa zostanie nagrana i transkrybowana przez Pine.",
    ninaPayAndCallCta: "Zapłać £2.99 i rozpocznij rozmowę",
    ninaCheckoutFailed: "Nie udało się rozpocząć płatności. Spróbuj ponownie.",
    // Wynik negocjacji (Etap 4)
    ninaDealAgreed: "Umowa zawarta!",
    ninaWasAsking: "Chciał",
    ninaAgreedAt: "Zgodził się na",
    ninaSavedYou: "Zaoszczędziłeś",
    ninaSellerSaid: "Sprzedawca powiedział",
    ninaNoAnswer: "Nikt nie odebrał",
    ninaNoDeal: "Nie udało się dogadać",
    ninaDealPdfDownload: "Zapisz umowę jako PDF",
    ninaDealPdfPreparing: "Przygotowuję Twój PDF…",
    ninaDealEmailToggle: "Wyślij PDF emailem",
    ninaDealEmailPlaceholder: "twoj@email.com",
    ninaDealEmailSend: "Wyślij",
    ninaDealEmailSending: "Wysyłam…",
    ninaDealEmailSent: "Wysłano",
    priceNoAskingLabel: "Dodaj cenę sprzedawcy",
    priceNoAskingHeadline: "Wpisz cenę żądaną przez sprzedawcę, żeby zobaczyć werdykt.",
    priceNoAskingSub: "Bez niej pokażemy Ci zakres rynkowy, ale nie powiemy czy oferta jest fair, zawyżona czy podejrzana.",
    priceNoAskingCta: "Sprawdź werdykt",
    priceAskingPlaceholder: "np. £6,500",
    priceAskingHintMedian: "np.",
    ninaToastPaid: "Płatność potwierdzona",
    ninaToastCallingNamed: "Nina właśnie dzwoni do {name}…",
    ninaToastCallingGeneric: "Nina właśnie dzwoni do sprzedawcy…",
    ninaToastInProgress: "Nina rozmawia",
    ninaToastNegotiatingNamed: "Negocjuje z {name}…",
    ninaToastNegotiatingGeneric: "Negocjuje ze sprzedawcą…",
    ninaToastDealHeadline: "Umowa zawarta!",
    ninaToastSavedYou: "Zaoszczędziłeś £{amount}",
    ninaToastCallComplete: "Rozmowa zakończona",
    ninaToastCallCompleteSub: "Otwórz Ninę, by zobaczyć pełen transkrypt.",
    ninaToastCallFailed: "Nie udało się połączyć",
    // Share win toast button
    ninaShareWinCta: "Pochwal się",
    ninaShareWinTitle: "Zaoszczędziłem £{amount} z Worthify",
    ninaShareWinText: "Właśnie zaoszczędziłem £{amount} na używanym samochodzie dzięki Worthify Nina 📞 — to AI co-pilot który dzwoni do sprzedawcy i negocjuje za Ciebie.",
    // Share z mechanikiem
    shareMechanicTitle: "Wyślij mechanikowi",
    shareMechanicSubtitle: "Druga opinia przed zakupem. Raport otwiera się read-only — mechanik nie musi nic płacić.",
    shareMechanicMessage: "Rzuć okiem na ten raport zanim kupię. To {vehicle} ({reg}). Niezależna analiza MOT + AI z Worthify:",
    shareMechanicEmailSubject: "Raport Worthify dla {reg}",
    shareMechanicEmail: "Email",
    shareMechanicCopy: "Skopiuj link",
    shareMechanicCopied: "Skopiowane!",
    shareMechanicMoreOptions: "Więcej opcji udostępniania",
    // Aparat OCR (skanowanie tablicy / VIN)
    scanPlateAria: "Zeskanuj tablicę aparatem",
    scanVinAria: "Zeskanuj VIN aparatem",
    scanPlateNotFound: "Nie wykryto tablicy. Spróbuj bliżej i z lepszym oświetleniem.",
    scanVinNotFound: "Nie wykryto VIN. Spróbuj bliżej i z lepszym oświetleniem.",
    scanGenericError: "Nie udało się odczytać obrazu. Spróbuj ponownie.",
    // Pierwszy raz — tutorial aparatu
    scanTutorialPlateTitle: "Idealne ujęcie tablicy",
    scanTutorialPlateSubtitle: "Trzy szybkie wskazówki dla pewnego rozpoznania.",
    scanTutorialVinTitle: "Idealne ujęcie VIN",
    scanTutorialVinSubtitle: "VIN jest mały — trzymaj aparat stabilnie.",
    scanTipCenter: "Wycentruj tablicę w kadrze",
    scanTipLight: "Dobre oświetlenie (bez cieni)",
    scanTipClose: "Bliżej — tablica powinna zajmować większość zdjęcia",
    scanTipVinLocation: "VIN jest na desce rozdzielczej (przez szybę) lub na słupku drzwi kierowcy",
    scanTipVinClose: "Bliżej — 17 znaków powinno zajmować większość zdjęcia",
    scanTutorialCta: "Rozumiem — otwórz aparat",
    scanTutorialSkip: "Anuluj",

    // ── Dodatek przyjazny osobom z niepełnosprawnościami (Sesja H15) ──
    disabilityBadge: "PRZYJAZNE OSOBOM Z NIEPEŁNOSPRAWNOŚCIAMI",
    ninaAutoCallTitle: "Autonomiczna rozmowa za Ciebie",
    ninaAutoCallPoweredBy: "napędzane przez Pine.ai",
    ninaAutoCallDesc: "Worthify wykonuje rozmowę negocjacyjną w Twoim imieniu, aby uzyskać najlepszą możliwą cenę — Ty nie musisz się o nic martwić. Idealne dla osób niesłyszących, niemówiących lub mających trudności z rozmowami telefonicznymi.",
    ninaAutoCallPerCall: "za połączenie",
    heroDisabilityBadge: "Aplikacja przyjazna osobom z niepełnosprawnościami — pomagamy tym, którzy najbardziej tego potrzebują",

    // ── Premium: prawdziwe dane rejestrowe (Vehicle Data Global) ──
    gvdSourceNote: "Dane na żywo z rejestru DVLA",
    accidentSourceNote: "Dane na żywo z MIAFTR + historii pojazdu DVLA",
    miaftrSourceNote: "Dane na żywo z MIAFTR (rejestr ubezpieczycieli — szkody totalne)",
    financeSourceNote: "Dane na żywo z rejestru HPI / Experian (finansowanie)",
    ownersKeeperLabel: "Właściciel",
    ownersSinceLabel: "od",
    registryChecksTitle: "Kontrole w rejestrze DVLA",
    importedFlagLabel: "Importowany",
    importOutsideEuLabel: "Import spoza UE",
    importExportedLabel: "Wyeksportowany",
    importScrappedLabel: "Zezłomowany",
    ukSuppliedLabel: "Dostarczony w UK",
    flaggedLabel: "Oznaczony",
    notFlaggedLabel: "Brak wpisu",
    liveValuationTitle: "Wycena rynkowa na żywo",
    valDealerForecourt: "Cena u dealera",
    valPrivateClean: "Sprzedaż prywatna (b. dobry stan)",
    valPartExchange: "Rozliczenie w komisie",
    valAuction: "Aukcja",
    valMileageNote: "Wycena przy przebiegu {miles} mil · dane branżowe na żywo",
    tyreFitmentTitle: "Fabryczne ogumienie",
    tyreFrontLabel: "Przód",
    tyreRearLabel: "Tył",
    priceEvalLabel: "Ocena ceny",
    mileageTileLabel: "Przebieg",
    dvlaSubtitle: "Agencja Licencjonowania Kierowców i Pojazdów",
    dvsaSubtitle: "Agencja Standardów Kierowców i Pojazdów",
    dvsaOfficialData: "Oficjalne dane MOT",
    poweredBy: "Powered by",
    gvdSubtitle: "Partner danych pojazdów komercyjnych",
    hpiSubtitle: "Więcej danych niż standardowy check HPI",
    errorInvalidRegistration: "Ten numer rejestracyjny wygląda niepoprawnie — sprawdź tablicę i spróbuj ponownie.",

};
